import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import { getCongressionalDistNames } from "../components/discovery/filter/customFilters/FilterHelper"
import { getAppConfig } from "../utils/ReduxHelper";

const FilterPopulationService = {
  getCongressionalDistNames: function (config) {
    try
    {
      const queryObject = new Query({
          where: "(OBJECTID IS NOT NULL)",
          outFields: "NAME, BASENAME, STATE",
          returnGeometry: false,
      });
      if(config){
        return query.executeQueryJSON(config.congressionalDistrict.url, queryObject).then(results => {
          const states = getCongressionalDistNames();
          let congDists = [];
          let finalItems = [];
          if(results.features) {
            congDists = results.features.map((eaGroup) => eaGroup.attributes);
            congDists.forEach((item) => {
              const state = states.filter(x => x.code === item.STATE);
              let stateItem = {"name": "", "code": ""};
              if(state && state.length > 0){
                stateItem = state[0];
              }
              const obj = `${stateItem.name}-${item.BASENAME}`;
              finalItems.push(obj);
            });
            finalItems.sort((a, b) => {
              return ((a.name < b.name) ? -1 : 1);
            })
          } 
          return finalItems;
        });
      } else {
        throw Error("Missing Config");
      }
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getStateRecords: function () {
    try
    {
      const config = getAppConfig()
      const queryObject = new Query({
          where: "(OBJECTID IS NOT NULL)",
          outFields: "NAME, BASENAME, STATE, GEOID, STUSAB",
          returnGeometry: false,
      });
      if(config){
        return query.executeQueryJSON(config.state.url, queryObject).then(results => {
          let finalItems = [];
          if(results.features) {
            finalItems = results.features.map((eaGroup) => eaGroup.attributes);
          } 
          return finalItems;
        });
      } else {
        throw Error("Missing Config");
      }
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getCountyRecords: function () {
    try
    {
      const config = getAppConfig()
      const queryObject = new Query({
          where: "(OBJECTID IS NOT NULL)",
          outFields: "NAME, BASENAME, STATE, COUNTY, GEOID",
          returnGeometry: false,
      });
      if(config){
        return query.executeQueryJSON(config.county.url, queryObject).then(results => {
          let finalItems = [];
          if(results.features) {
            finalItems = results.features.map((eaGroup) => eaGroup.attributes);
          } 
          return finalItems;
        });
      } else {
        return this.getStaticCounties();
      }
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        console.log(e);
        resolve(this.getStaticCounties());
      });
    }
  },
  getStaticCounties: function () {
    return [
      "Abbeville - South Carolina",
      "Acadia Parish - Louisiana",
      "Accomack - Virginia",
      "Ada - Idaho",
      "Adair - Iowa",
      "Adair - Kentucky",
      "Adair - Missouri",
      "Adair - Oklahoma",
      "Adams - Colorado",
      "Adams - Idaho",
      "Adams - Illinois",
      "Adams - Indiana",
      "Adams - Iowa",
      "Adams - Mississippi",
      "Adams - Nebraska",
      "Adams - North Dakota",
      "Adams - Ohio",
      "Adams - Pennsylvania",
      "Adams - Washington",
      "Adams - Wisconsin",
      "Addison - Vermont",
      "Adjuntas Municipio - Puerto Rico",
      "Aguada Municipio - Puerto Rico",
      "Aguadilla Municipio - Puerto Rico",
      "Aguas Buenas Municipio - Puerto Rico",
      "Aibonito Municipio - Puerto Rico",
      "Aiken - South Carolina",
      "Aitkin - Minnesota",
      "Alachua - Florida",
      "Alamance - North Carolina",
      "Alameda - California",
      "Alamosa - Colorado",
      "Albany - New York",
      "Albany - Wyoming",
      "Albemarle - Virginia",
      "Alcona - Michigan",
      "Alcorn - Mississippi",
      "Aleutians East Borough - Alaska",
      "Aleutians West Census Area - Alaska",
      "Alexander - Illinois",
      "Alexander - North Carolina",
      "Alexandria city - Virginia",
      "Alfalfa - Oklahoma",
      "Alger - Michigan",
      "Allamakee - Iowa",
      "Allegan - Michigan",
      "Allegany - Maryland",
      "Allegany - New York",
      "Alleghany - North Carolina",
      "Alleghany - Virginia",
      "Allegheny - Pennsylvania",
      "Allen - Indiana",
      "Allen - Kansas",
      "Allen - Kentucky",
      "Allen - Ohio",
      "Allen Parish - Louisiana",
      "Allendale - South Carolina",
      "Alpena - Michigan",
      "Alpine - California",
      "Amador - California",
      "Amelia - Virginia",
      "Amherst - Virginia",
      "Amite - Mississippi",
      "Anchorage Municipality - Alaska",
      "Anderson - Kansas",
      "Anderson - Kentucky",
      "Anderson - South Carolina",
      "Anderson - Tennessee",
      "Anderson - Texas",
      "Andrew - Missouri",
      "Andrews - Texas",
      "Androscoggin - Maine",
      "Angelina - Texas",
      "Anne Arundel - Maryland",
      "Anoka - Minnesota",
      "Anson - North Carolina",
      "Antelope - Nebraska",
      "Antrim - Michigan",
      "Apache - Arizona",
      "Appanoose - Iowa",
      "Appling - Georgia",
      "Appomattox - Virginia",
      "Aransas - Texas",
      "Arapahoe - Colorado",
      "Archer - Texas",
      "Archuleta - Colorado",
      "Arecibo Municipio - Puerto Rico",
      "Arenac - Michigan",
      "Arkansas - Arkansas",
      "Arlington - Virginia",
      "Armstrong - Pennsylvania",
      "Armstrong - Texas",
      "Aroostook - Maine",
      "Arroyo Municipio - Puerto Rico",
      "Arthur - Nebraska",
      "Ascension Parish - Louisiana",
      "Ashe - North Carolina",
      "Ashland - Ohio",
      "Ashland - Wisconsin",
      "Ashley - Arkansas",
      "Ashtabula - Ohio",
      "Asotin - Washington",
      "Assumption Parish - Louisiana",
      "Atascosa - Texas",
      "Atchison - Kansas",
      "Atchison - Missouri",
      "Athens - Ohio",
      "Atkinson - Georgia",
      "Atlantic - New Jersey",
      "Atoka - Oklahoma",
      "Attala - Mississippi",
      "Audrain - Missouri",
      "Audubon - Iowa",
      "Auglaize - Ohio",
      "Augusta - Virginia",
      "Aurora - South Dakota",
      "Austin - Texas",
      "Autauga - Alabama",
      "Avery - North Carolina",
      "Avoyelles Parish - Louisiana",
      "Añasco Municipio - Puerto Rico",
      "Baca - Colorado",
      "Bacon - Georgia",
      "Bailey - Texas",
      "Baker - Florida",
      "Baker - Georgia",
      "Baker - Oregon",
      "Baldwin - Alabama",
      "Baldwin - Georgia",
      "Ballard - Kentucky",
      "Baltimore - Maryland",
      "Baltimore city - Maryland",
      "Bamberg - South Carolina",
      "Bandera - Texas",
      "Banks - Georgia",
      "Banner - Nebraska",
      "Bannock - Idaho",
      "Baraga - Michigan",
      "Barber - Kansas",
      "Barbour - Alabama",
      "Barbour - West Virginia",
      "Barceloneta Municipio - Puerto Rico",
      "Barnes - North Dakota",
      "Barnstable - Massachusetts",
      "Barnwell - South Carolina",
      "Barranquitas Municipio - Puerto Rico",
      "Barren - Kentucky",
      "Barron - Wisconsin",
      "Barrow - Georgia",
      "Barry - Michigan",
      "Barry - Missouri",
      "Bartholomew - Indiana",
      "Barton - Kansas",
      "Barton - Missouri",
      "Bartow - Georgia",
      "Bastrop - Texas",
      "Bates - Missouri",
      "Bath - Kentucky",
      "Bath - Virginia",
      "Baxter - Arkansas",
      "Bay - Florida",
      "Bay - Michigan",
      "Bayamón Municipio - Puerto Rico",
      "Bayfield - Wisconsin",
      "Baylor - Texas",
      "Beadle - South Dakota",
      "Bear Lake - Idaho",
      "Beaufort - North Carolina",
      "Beaufort - South Carolina",
      "Beauregard Parish - Louisiana",
      "Beaver - Oklahoma",
      "Beaver - Pennsylvania",
      "Beaver - Utah",
      "Beaverhead - Montana",
      "Becker - Minnesota",
      "Beckham - Oklahoma",
      "Bedford - Pennsylvania",
      "Bedford - Tennessee",
      "Bedford - Virginia",
      "Bee - Texas",
      "Belknap - New Hampshire",
      "Bell - Kentucky",
      "Bell - Texas",
      "Belmont - Ohio",
      "Beltrami - Minnesota",
      "Ben Hill - Georgia",
      "Benewah - Idaho",
      "Bennett - South Dakota",
      "Bennington - Vermont",
      "Benson - North Dakota",
      "Bent - Colorado",
      "Benton - Arkansas",
      "Benton - Indiana",
      "Benton - Iowa",
      "Benton - Minnesota",
      "Benton - Mississippi",
      "Benton - Missouri",
      "Benton - Oregon",
      "Benton - Tennessee",
      "Benton - Washington",
      "Benzie - Michigan",
      "Bergen - New Jersey",
      "Berkeley - South Carolina",
      "Berkeley - West Virginia",
      "Berks - Pennsylvania",
      "Berkshire - Massachusetts",
      "Bernalillo - New Mexico",
      "Berrien - Georgia",
      "Berrien - Michigan",
      "Bertie - North Carolina",
      "Bethel Census Area - Alaska",
      "Bexar - Texas",
      "Bibb - Alabama",
      "Bibb - Georgia",
      "Bienville Parish - Louisiana",
      "Big Horn - Montana",
      "Big Horn - Wyoming",
      "Big Stone - Minnesota",
      "Billings - North Dakota",
      "Bingham - Idaho",
      "Black Hawk - Iowa",
      "Blackford - Indiana",
      "Bladen - North Carolina",
      "Blaine - Idaho",
      "Blaine - Montana",
      "Blaine - Nebraska",
      "Blaine - Oklahoma",
      "Blair - Pennsylvania",
      "Blanco - Texas",
      "Bland - Virginia",
      "Bleckley - Georgia",
      "Bledsoe - Tennessee",
      "Blount - Alabama",
      "Blount - Tennessee",
      "Blue Earth - Minnesota",
      "Boise - Idaho",
      "Bolivar - Mississippi",
      "Bollinger - Missouri",
      "Bon Homme - South Dakota",
      "Bond - Illinois",
      "Bonner - Idaho",
      "Bonneville - Idaho",
      "Boone - Arkansas",
      "Boone - Illinois",
      "Boone - Indiana",
      "Boone - Iowa",
      "Boone - Kentucky",
      "Boone - Missouri",
      "Boone - Nebraska",
      "Boone - West Virginia",
      "Borden - Texas",
      "Bosque - Texas",
      "Bossier Parish - Louisiana",
      "Botetourt - Virginia",
      "Bottineau - North Dakota",
      "Boulder - Colorado",
      "Boundary - Idaho",
      "Bourbon - Kansas",
      "Bourbon - Kentucky",
      "Bowie - Texas",
      "Bowman - North Dakota",
      "Box Butte - Nebraska",
      "Box Elder - Utah",
      "Boyd - Kentucky",
      "Boyd - Nebraska",
      "Boyle - Kentucky",
      "Bracken - Kentucky",
      "Bradford - Florida",
      "Bradford - Pennsylvania",
      "Bradley - Arkansas",
      "Bradley - Tennessee",
      "Branch - Michigan",
      "Brantley - Georgia",
      "Braxton - West Virginia",
      "Brazoria - Texas",
      "Brazos - Texas",
      "Breathitt - Kentucky",
      "Breckinridge - Kentucky",
      "Bremer - Iowa",
      "Brevard - Florida",
      "Brewster - Texas",
      "Briscoe - Texas",
      "Bristol - Massachusetts",
      "Bristol - Rhode Island",
      "Bristol Bay Borough - Alaska",
      "Bristol city - Virginia",
      "Broadwater - Montana",
      "Bronx - New York",
      "Brooke - West Virginia",
      "Brookings - South Dakota",
      "Brooks - Georgia",
      "Brooks - Texas",
      "Broome - New York",
      "Broomfield - Colorado",
      "Broward - Florida",
      "Brown - Illinois",
      "Brown - Indiana",
      "Brown - Kansas",
      "Brown - Minnesota",
      "Brown - Nebraska",
      "Brown - Ohio",
      "Brown - South Dakota",
      "Brown - Texas",
      "Brown - Wisconsin",
      "Brule - South Dakota",
      "Brunswick - North Carolina",
      "Brunswick - Virginia",
      "Bryan - Georgia",
      "Bryan - Oklahoma",
      "Buchanan - Iowa",
      "Buchanan - Missouri",
      "Buchanan - Virginia",
      "Buckingham - Virginia",
      "Bucks - Pennsylvania",
      "Buena Vista - Iowa",
      "Buena Vista city - Virginia",
      "Buffalo - Nebraska",
      "Buffalo - South Dakota",
      "Buffalo - Wisconsin",
      "Bullitt - Kentucky",
      "Bulloch - Georgia",
      "Bullock - Alabama",
      "Buncombe - North Carolina",
      "Bureau - Illinois",
      "Burke - Georgia",
      "Burke - North Carolina",
      "Burke - North Dakota",
      "Burleigh - North Dakota",
      "Burleson - Texas",
      "Burlington - New Jersey",
      "Burnet - Texas",
      "Burnett - Wisconsin",
      "Burt - Nebraska",
      "Butler - Alabama",
      "Butler - Iowa",
      "Butler - Kansas",
      "Butler - Kentucky",
      "Butler - Missouri",
      "Butler - Nebraska",
      "Butler - Ohio",
      "Butler - Pennsylvania",
      "Butte - California",
      "Butte - Idaho",
      "Butte - South Dakota",
      "Butts - Georgia",
      "Cabarrus - North Carolina",
      "Cabell - West Virginia",
      "Cabo Rojo Municipio - Puerto Rico",
      "Cache - Utah",
      "Caddo - Oklahoma",
      "Caddo Parish - Louisiana",
      "Caguas Municipio - Puerto Rico",
      "Calaveras - California",
      "Calcasieu Parish - Louisiana",
      "Caldwell - Kentucky",
      "Caldwell - Missouri",
      "Caldwell - North Carolina",
      "Caldwell - Texas",
      "Caldwell Parish - Louisiana",
      "Caledonia - Vermont",
      "Calhoun - Alabama",
      "Calhoun - Arkansas",
      "Calhoun - Florida",
      "Calhoun - Georgia",
      "Calhoun - Illinois",
      "Calhoun - Iowa",
      "Calhoun - Michigan",
      "Calhoun - Mississippi",
      "Calhoun - South Carolina",
      "Calhoun - Texas",
      "Calhoun - West Virginia",
      "Callahan - Texas",
      "Callaway - Missouri",
      "Calloway - Kentucky",
      "Calumet - Wisconsin",
      "Calvert - Maryland",
      "Camas - Idaho",
      "Cambria - Pennsylvania",
      "Camden - Georgia",
      "Camden - Missouri",
      "Camden - New Jersey",
      "Camden - North Carolina",
      "Cameron - Pennsylvania",
      "Cameron - Texas",
      "Cameron Parish - Louisiana",
      "Camp - Texas",
      "Campbell - Kentucky",
      "Campbell - South Dakota",
      "Campbell - Tennessee",
      "Campbell - Virginia",
      "Campbell - Wyoming",
      "Camuy Municipio - Puerto Rico",
      "Canadian - Oklahoma",
      "Candler - Georgia",
      "Cannon - Tennessee",
      "Canyon - Idaho",
      "Canóvanas Municipio - Puerto Rico",
      "Cape Girardeau - Missouri",
      "Cape May - New Jersey",
      "Carbon - Montana",
      "Carbon - Pennsylvania",
      "Carbon - Utah",
      "Carbon - Wyoming",
      "Caribou - Idaho",
      "Carlisle - Kentucky",
      "Carlton - Minnesota",
      "Carolina Municipio - Puerto Rico",
      "Caroline - Maryland",
      "Caroline - Virginia",
      "Carroll - Arkansas",
      "Carroll - Georgia",
      "Carroll - Illinois",
      "Carroll - Indiana",
      "Carroll - Iowa",
      "Carroll - Kentucky",
      "Carroll - Maryland",
      "Carroll - Mississippi",
      "Carroll - Missouri",
      "Carroll - New Hampshire",
      "Carroll - Ohio",
      "Carroll - Tennessee",
      "Carroll - Virginia",
      "Carson - Texas",
      "Carson City - Nevada",
      "Carter - Kentucky",
      "Carter - Missouri",
      "Carter - Montana",
      "Carter - Oklahoma",
      "Carter - Tennessee",
      "Carteret - North Carolina",
      "Carver - Minnesota",
      "Cascade - Montana",
      "Casey - Kentucky",
      "Cass - Illinois",
      "Cass - Indiana",
      "Cass - Iowa",
      "Cass - Michigan",
      "Cass - Minnesota",
      "Cass - Missouri",
      "Cass - Nebraska",
      "Cass - North Dakota",
      "Cass - Texas",
      "Cassia - Idaho",
      "Castro - Texas",
      "Caswell - North Carolina",
      "Catahoula Parish - Louisiana",
      "Catawba - North Carolina",
      "Cataño Municipio - Puerto Rico",
      "Catoosa - Georgia",
      "Catron - New Mexico",
      "Cattaraugus - New York",
      "Cavalier - North Dakota",
      "Cayey Municipio - Puerto Rico",
      "Cayuga - New York",
      "Cecil - Maryland",
      "Cedar - Iowa",
      "Cedar - Missouri",
      "Cedar - Nebraska",
      "Ceiba Municipio - Puerto Rico",
      "Centre - Pennsylvania",
      "Cerro Gordo - Iowa",
      "Chaffee - Colorado",
      "Chambers - Alabama",
      "Chambers - Texas",
      "Champaign - Illinois",
      "Champaign - Ohio",
      "Chariton - Missouri",
      "Charles - Maryland",
      "Charles City - Virginia",
      "Charles Mix - South Dakota",
      "Charleston - South Carolina",
      "Charlevoix - Michigan",
      "Charlotte - Florida",
      "Charlotte - Virginia",
      "Charlottesville city - Virginia",
      "Charlton - Georgia",
      "Chase - Kansas",
      "Chase - Nebraska",
      "Chatham - Georgia",
      "Chatham - North Carolina",
      "Chattahoochee - Georgia",
      "Chattooga - Georgia",
      "Chautauqua - Kansas",
      "Chautauqua - New York",
      "Chaves - New Mexico",
      "Cheatham - Tennessee",
      "Cheboygan - Michigan",
      "Chelan - Washington",
      "Chemung - New York",
      "Chenango - New York",
      "Cherokee - Alabama",
      "Cherokee - Georgia",
      "Cherokee - Iowa",
      "Cherokee - Kansas",
      "Cherokee - North Carolina",
      "Cherokee - Oklahoma",
      "Cherokee - South Carolina",
      "Cherokee - Texas",
      "Cherry - Nebraska",
      "Chesapeake city - Virginia",
      "Cheshire - New Hampshire",
      "Chester - Pennsylvania",
      "Chester - South Carolina",
      "Chester - Tennessee",
      "Chesterfield - South Carolina",
      "Chesterfield - Virginia",
      "Cheyenne - Colorado",
      "Cheyenne - Kansas",
      "Cheyenne - Nebraska",
      "Chickasaw - Iowa",
      "Chickasaw - Mississippi",
      "Chicot - Arkansas",
      "Childress - Texas",
      "Chilton - Alabama",
      "Chippewa - Michigan",
      "Chippewa - Minnesota",
      "Chippewa - Wisconsin",
      "Chisago - Minnesota",
      "Chittenden - Vermont",
      "Choctaw - Alabama",
      "Choctaw - Mississippi",
      "Choctaw - Oklahoma",
      "Chouteau - Montana",
      "Chowan - North Carolina",
      "Christian - Illinois",
      "Christian - Kentucky",
      "Christian - Missouri",
      "Chugach Census Area - Alaska",
      "Churchill - Nevada",
      "Ciales Municipio - Puerto Rico",
      "Cibola - New Mexico",
      "Cidra Municipio - Puerto Rico",
      "Cimarron - Oklahoma",
      "Citrus - Florida",
      "Clackamas - Oregon",
      "Claiborne - Mississippi",
      "Claiborne - Tennessee",
      "Claiborne Parish - Louisiana",
      "Clallam - Washington",
      "Clare - Michigan",
      "Clarendon - South Carolina",
      "Clarion - Pennsylvania",
      "Clark - Arkansas",
      "Clark - Idaho",
      "Clark - Illinois",
      "Clark - Indiana",
      "Clark - Kansas",
      "Clark - Kentucky",
      "Clark - Missouri",
      "Clark - Nevada",
      "Clark - Ohio",
      "Clark - South Dakota",
      "Clark - Washington",
      "Clark - Wisconsin",
      "Clarke - Alabama",
      "Clarke - Georgia",
      "Clarke - Iowa",
      "Clarke - Mississippi",
      "Clarke - Virginia",
      "Clatsop - Oregon",
      "Clay - Alabama",
      "Clay - Arkansas",
      "Clay - Florida",
      "Clay - Georgia",
      "Clay - Illinois",
      "Clay - Indiana",
      "Clay - Iowa",
      "Clay - Kansas",
      "Clay - Kentucky",
      "Clay - Minnesota",
      "Clay - Mississippi",
      "Clay - Missouri",
      "Clay - Nebraska",
      "Clay - North Carolina",
      "Clay - South Dakota",
      "Clay - Tennessee",
      "Clay - Texas",
      "Clay - West Virginia",
      "Clayton - Georgia",
      "Clayton - Iowa",
      "Clear Creek - Colorado",
      "Clearfield - Pennsylvania",
      "Clearwater - Idaho",
      "Clearwater - Minnesota",
      "Cleburne - Alabama",
      "Cleburne - Arkansas",
      "Clermont - Ohio",
      "Cleveland - Arkansas",
      "Cleveland - North Carolina",
      "Cleveland - Oklahoma",
      "Clinch - Georgia",
      "Clinton - Illinois",
      "Clinton - Indiana",
      "Clinton - Iowa",
      "Clinton - Kentucky",
      "Clinton - Michigan",
      "Clinton - Missouri",
      "Clinton - New York",
      "Clinton - Ohio",
      "Clinton - Pennsylvania",
      "Cloud - Kansas",
      "Coahoma - Mississippi",
      "Coal - Oklahoma",
      "Coamo Municipio - Puerto Rico",
      "Cobb - Georgia",
      "Cochise - Arizona",
      "Cochran - Texas",
      "Cocke - Tennessee",
      "Coconino - Arizona",
      "Codington - South Dakota",
      "Coffee - Alabama",
      "Coffee - Georgia",
      "Coffee - Tennessee",
      "Coffey - Kansas",
      "Coke - Texas",
      "Colbert - Alabama",
      "Cole - Missouri",
      "Coleman - Texas",
      "Coles - Illinois",
      "Colfax - Nebraska",
      "Colfax - New Mexico",
      "Colleton - South Carolina",
      "Collier - Florida",
      "Collin - Texas",
      "Collingsworth - Texas",
      "Colonial Heights city - Virginia",
      "Colorado - Texas",
      "Colquitt - Georgia",
      "Columbia - Arkansas",
      "Columbia - Florida",
      "Columbia - Georgia",
      "Columbia - New York",
      "Columbia - Oregon",
      "Columbia - Pennsylvania",
      "Columbia - Washington",
      "Columbia - Wisconsin",
      "Columbiana - Ohio",
      "Columbus - North Carolina",
      "Colusa - California",
      "Comal - Texas",
      "Comanche - Kansas",
      "Comanche - Oklahoma",
      "Comanche - Texas",
      "Comerío Municipio - Puerto Rico",
      "Concho - Texas",
      "Concordia Parish - Louisiana",
      "Conecuh - Alabama",
      "Conejos - Colorado",
      "Contra Costa - California",
      "Converse - Wyoming",
      "Conway - Arkansas",
      "Cook - Georgia",
      "Cook - Illinois",
      "Cook - Minnesota",
      "Cooke - Texas",
      "Cooper - Missouri",
      "Coos - New Hampshire",
      "Coos - Oregon",
      "Coosa - Alabama",
      "Copiah - Mississippi",
      "Copper River Census Area - Alaska",
      "Corozal Municipio - Puerto Rico",
      "Corson - South Dakota",
      "Cortland - New York",
      "Coryell - Texas",
      "Coshocton - Ohio",
      "Costilla - Colorado",
      "Cottle - Texas",
      "Cotton - Oklahoma",
      "Cottonwood - Minnesota",
      "Covington - Alabama",
      "Covington - Mississippi",
      "Covington city - Virginia",
      "Coweta - Georgia",
      "Cowley - Kansas",
      "Cowlitz - Washington",
      "Craig - Oklahoma",
      "Craig - Virginia",
      "Craighead - Arkansas",
      "Crane - Texas",
      "Craven - North Carolina",
      "Crawford - Arkansas",
      "Crawford - Georgia",
      "Crawford - Illinois",
      "Crawford - Indiana",
      "Crawford - Iowa",
      "Crawford - Kansas",
      "Crawford - Michigan",
      "Crawford - Missouri",
      "Crawford - Ohio",
      "Crawford - Pennsylvania",
      "Crawford - Wisconsin",
      "Creek - Oklahoma",
      "Crenshaw - Alabama",
      "Crisp - Georgia",
      "Crittenden - Arkansas",
      "Crittenden - Kentucky",
      "Crockett - Tennessee",
      "Crockett - Texas",
      "Crook - Oregon",
      "Crook - Wyoming",
      "Crosby - Texas",
      "Cross - Arkansas",
      "Crow Wing - Minnesota",
      "Crowley - Colorado",
      "Culberson - Texas",
      "Culebra Municipio - Puerto Rico",
      "Cullman - Alabama",
      "Culpeper - Virginia",
      "Cumberland - Illinois",
      "Cumberland - Kentucky",
      "Cumberland - Maine",
      "Cumberland - New Jersey",
      "Cumberland - North Carolina",
      "Cumberland - Pennsylvania",
      "Cumberland - Tennessee",
      "Cumberland - Virginia",
      "Cuming - Nebraska",
      "Currituck - North Carolina",
      "Curry - New Mexico",
      "Curry - Oregon",
      "Custer - Colorado",
      "Custer - Idaho",
      "Custer - Montana",
      "Custer - Nebraska",
      "Custer - Oklahoma",
      "Custer - South Dakota",
      "Cuyahoga - Ohio",
      "Dade - Georgia",
      "Dade - Missouri",
      "Daggett - Utah",
      "Dakota - Minnesota",
      "Dakota - Nebraska",
      "Dale - Alabama",
      "Dallam - Texas",
      "Dallas - Alabama",
      "Dallas - Arkansas",
      "Dallas - Iowa",
      "Dallas - Missouri",
      "Dallas - Texas",
      "Dane - Wisconsin",
      "Daniels - Montana",
      "Danville city - Virginia",
      "Dare - North Carolina",
      "Darke - Ohio",
      "Darlington - South Carolina",
      "Dauphin - Pennsylvania",
      "Davidson - North Carolina",
      "Davidson - Tennessee",
      "Davie - North Carolina",
      "Daviess - Indiana",
      "Daviess - Kentucky",
      "Daviess - Missouri",
      "Davis - Iowa",
      "Davis - Utah",
      "Davison - South Dakota",
      "Dawes - Nebraska",
      "Dawson - Georgia",
      "Dawson - Montana",
      "Dawson - Nebraska",
      "Dawson - Texas",
      "Day - South Dakota",
      "De Baca - New Mexico",
      "De Soto Parish - Louisiana",
      "De Witt - Illinois",
      "DeKalb - Alabama",
      "DeKalb - Georgia",
      "DeKalb - Illinois",
      "DeKalb - Indiana",
      "DeKalb - Missouri",
      "DeKalb - Tennessee",
      "DeSoto - Florida",
      "DeSoto - Mississippi",
      "DeWitt - Texas",
      "Deaf Smith - Texas",
      "Dearborn - Indiana",
      "Decatur - Georgia",
      "Decatur - Indiana",
      "Decatur - Iowa",
      "Decatur - Kansas",
      "Decatur - Tennessee",
      "Deer Lodge - Montana",
      "Defiance - Ohio",
      "Del Norte - California",
      "Delaware - Indiana",
      "Delaware - Iowa",
      "Delaware - New York",
      "Delaware - Ohio",
      "Delaware - Oklahoma",
      "Delaware - Pennsylvania",
      "Delta - Colorado",
      "Delta - Michigan",
      "Delta - Texas",
      "Denali Borough - Alaska",
      "Dent - Missouri",
      "Denton - Texas",
      "Denver - Colorado",
      "Des Moines - Iowa",
      "Deschutes - Oregon",
      "Desha - Arkansas",
      "Deuel - Nebraska",
      "Deuel - South Dakota",
      "Dewey - Oklahoma",
      "Dewey - South Dakota",
      "Dickens - Texas",
      "Dickenson - Virginia",
      "Dickey - North Dakota",
      "Dickinson - Iowa",
      "Dickinson - Kansas",
      "Dickinson - Michigan",
      "Dickson - Tennessee",
      "Dillingham Census Area - Alaska",
      "Dillon - South Carolina",
      "Dimmit - Texas",
      "Dinwiddie - Virginia",
      "District of Columbia - District of Columbia",
      "Divide - North Dakota",
      "Dixie - Florida",
      "Dixon - Nebraska",
      "Doddridge - West Virginia",
      "Dodge - Georgia",
      "Dodge - Minnesota",
      "Dodge - Nebraska",
      "Dodge - Wisconsin",
      "Dolores - Colorado",
      "Doniphan - Kansas",
      "Donley - Texas",
      "Dooly - Georgia",
      "Door - Wisconsin",
      "Dorado Municipio - Puerto Rico",
      "Dorchester - Maryland",
      "Dorchester - South Carolina",
      "Dougherty - Georgia",
      "Douglas - Colorado",
      "Douglas - Georgia",
      "Douglas - Illinois",
      "Douglas - Kansas",
      "Douglas - Minnesota",
      "Douglas - Missouri",
      "Douglas - Nebraska",
      "Douglas - Nevada",
      "Douglas - Oregon",
      "Douglas - South Dakota",
      "Douglas - Washington",
      "Douglas - Wisconsin",
      "Doña Ana - New Mexico",
      "Drew - Arkansas",
      "DuPage - Illinois",
      "Dubois - Indiana",
      "Dubuque - Iowa",
      "Duchesne - Utah",
      "Dukes - Massachusetts",
      "Dundy - Nebraska",
      "Dunklin - Missouri",
      "Dunn - North Dakota",
      "Dunn - Wisconsin",
      "Duplin - North Carolina",
      "Durham - North Carolina",
      "Dutchess - New York",
      "Duval - Florida",
      "Duval - Texas",
      "Dyer - Tennessee",
      "Eagle - Colorado",
      "Early - Georgia",
      "East Baton Rouge Parish - Louisiana",
      "East Carroll Parish - Louisiana",
      "East Feliciana Parish - Louisiana",
      "Eastern District - American Samoa",
      "Eastland - Texas",
      "Eaton - Michigan",
      "Eau Claire - Wisconsin",
      "Echols - Georgia",
      "Ector - Texas",
      "Eddy - New Mexico",
      "Eddy - North Dakota",
      "Edgar - Illinois",
      "Edgecombe - North Carolina",
      "Edgefield - South Carolina",
      "Edmonson - Kentucky",
      "Edmunds - South Dakota",
      "Edwards - Illinois",
      "Edwards - Kansas",
      "Edwards - Texas",
      "Effingham - Georgia",
      "Effingham - Illinois",
      "El Dorado - California",
      "El Paso - Colorado",
      "El Paso - Texas",
      "Elbert - Colorado",
      "Elbert - Georgia",
      "Elk - Kansas",
      "Elk - Pennsylvania",
      "Elkhart - Indiana",
      "Elko - Nevada",
      "Elliott - Kentucky",
      "Ellis - Kansas",
      "Ellis - Oklahoma",
      "Ellis - Texas",
      "Ellsworth - Kansas",
      "Elmore - Alabama",
      "Elmore - Idaho",
      "Emanuel - Georgia",
      "Emery - Utah",
      "Emmet - Iowa",
      "Emmet - Michigan",
      "Emmons - North Dakota",
      "Emporia city - Virginia",
      "Erath - Texas",
      "Erie - New York",
      "Erie - Ohio",
      "Erie - Pennsylvania",
      "Escambia - Alabama",
      "Escambia - Florida",
      "Esmeralda - Nevada",
      "Essex - Massachusetts",
      "Essex - New Jersey",
      "Essex - New York",
      "Essex - Vermont",
      "Essex - Virginia",
      "Estill - Kentucky",
      "Etowah - Alabama",
      "Eureka - Nevada",
      "Evangeline Parish - Louisiana",
      "Evans - Georgia",
      "Fairbanks North Star Borough - Alaska",
      "Fairfax - Virginia",
      "Fairfax city - Virginia",
      "Fairfield - Connecticut",
      "Fairfield - Ohio",
      "Fairfield - South Carolina",
      "Fajardo Municipio - Puerto Rico",
      "Fall River - South Dakota",
      "Fallon - Montana",
      "Falls - Texas",
      "Falls Church city - Virginia",
      "Fannin - Georgia",
      "Fannin - Texas",
      "Faribault - Minnesota",
      "Faulk - South Dakota",
      "Faulkner - Arkansas",
      "Fauquier - Virginia",
      "Fayette - Alabama",
      "Fayette - Georgia",
      "Fayette - Illinois",
      "Fayette - Indiana",
      "Fayette - Iowa",
      "Fayette - Kentucky",
      "Fayette - Ohio",
      "Fayette - Pennsylvania",
      "Fayette - Tennessee",
      "Fayette - Texas",
      "Fayette - West Virginia",
      "Fentress - Tennessee",
      "Fergus - Montana",
      "Ferry - Washington",
      "Fillmore - Minnesota",
      "Fillmore - Nebraska",
      "Finney - Kansas",
      "Fisher - Texas",
      "Flagler - Florida",
      "Flathead - Montana",
      "Fleming - Kentucky",
      "Florence - South Carolina",
      "Florence - Wisconsin",
      "Florida Municipio - Puerto Rico",
      "Floyd - Georgia",
      "Floyd - Indiana",
      "Floyd - Iowa",
      "Floyd - Kentucky",
      "Floyd - Texas",
      "Floyd - Virginia",
      "Fluvanna - Virginia",
      "Foard - Texas",
      "Fond du Lac - Wisconsin",
      "Ford - Illinois",
      "Ford - Kansas",
      "Forest - Pennsylvania",
      "Forest - Wisconsin",
      "Forrest - Mississippi",
      "Forsyth - Georgia",
      "Forsyth - North Carolina",
      "Fort Bend - Texas",
      "Foster - North Dakota",
      "Fountain - Indiana",
      "Franklin - Alabama",
      "Franklin - Arkansas",
      "Franklin - Florida",
      "Franklin - Georgia",
      "Franklin - Idaho",
      "Franklin - Illinois",
      "Franklin - Indiana",
      "Franklin - Iowa",
      "Franklin - Kansas",
      "Franklin - Kentucky",
      "Franklin - Maine",
      "Franklin - Massachusetts",
      "Franklin - Mississippi",
      "Franklin - Missouri",
      "Franklin - Nebraska",
      "Franklin - New York",
      "Franklin - North Carolina",
      "Franklin - Ohio",
      "Franklin - Pennsylvania",
      "Franklin - Tennessee",
      "Franklin - Texas",
      "Franklin - Vermont",
      "Franklin - Virginia",
      "Franklin - Washington",
      "Franklin Parish - Louisiana",
      "Franklin city - Virginia",
      "Frederick - Maryland",
      "Frederick - Virginia",
      "Fredericksburg city - Virginia",
      "Freeborn - Minnesota",
      "Freestone - Texas",
      "Fremont - Colorado",
      "Fremont - Idaho",
      "Fremont - Iowa",
      "Fremont - Wyoming",
      "Fresno - California",
      "Frio - Texas",
      "Frontier - Nebraska",
      "Fulton - Arkansas",
      "Fulton - Georgia",
      "Fulton - Illinois",
      "Fulton - Indiana",
      "Fulton - Kentucky",
      "Fulton - New York",
      "Fulton - Ohio",
      "Fulton - Pennsylvania",
      "Furnas - Nebraska",
      "Gadsden - Florida",
      "Gage - Nebraska",
      "Gaines - Texas",
      "Galax city - Virginia",
      "Gallatin - Illinois",
      "Gallatin - Kentucky",
      "Gallatin - Montana",
      "Gallia - Ohio",
      "Galveston - Texas",
      "Garden - Nebraska",
      "Garfield - Colorado",
      "Garfield - Montana",
      "Garfield - Nebraska",
      "Garfield - Oklahoma",
      "Garfield - Utah",
      "Garfield - Washington",
      "Garland - Arkansas",
      "Garrard - Kentucky",
      "Garrett - Maryland",
      "Garvin - Oklahoma",
      "Garza - Texas",
      "Gasconade - Missouri",
      "Gaston - North Carolina",
      "Gates - North Carolina",
      "Geary - Kansas",
      "Geauga - Ohio",
      "Gem - Idaho",
      "Genesee - Michigan",
      "Genesee - New York",
      "Geneva - Alabama",
      "Gentry - Missouri",
      "George - Mississippi",
      "Georgetown - South Carolina",
      "Gibson - Indiana",
      "Gibson - Tennessee",
      "Gila - Arizona",
      "Gilchrist - Florida",
      "Giles - Tennessee",
      "Giles - Virginia",
      "Gillespie - Texas",
      "Gilliam - Oregon",
      "Gilmer - Georgia",
      "Gilmer - West Virginia",
      "Gilpin - Colorado",
      "Glacier - Montana",
      "Glades - Florida",
      "Gladwin - Michigan",
      "Glascock - Georgia",
      "Glasscock - Texas",
      "Glenn - California",
      "Gloucester - New Jersey",
      "Gloucester - Virginia",
      "Glynn - Georgia",
      "Gogebic - Michigan",
      "Golden Valley - Montana",
      "Golden Valley - North Dakota",
      "Goliad - Texas",
      "Gonzales - Texas",
      "Goochland - Virginia",
      "Goodhue - Minnesota",
      "Gooding - Idaho",
      "Gordon - Georgia",
      "Goshen - Wyoming",
      "Gosper - Nebraska",
      "Gove - Kansas",
      "Grady - Georgia",
      "Grady - Oklahoma",
      "Grafton - New Hampshire",
      "Graham - Arizona",
      "Graham - Kansas",
      "Graham - North Carolina",
      "Grainger - Tennessee",
      "Grand - Colorado",
      "Grand - Utah",
      "Grand Forks - North Dakota",
      "Grand Isle - Vermont",
      "Grand Traverse - Michigan",
      "Granite - Montana",
      "Grant - Arkansas",
      "Grant - Indiana",
      "Grant - Kansas",
      "Grant - Kentucky",
      "Grant - Minnesota",
      "Grant - Nebraska",
      "Grant - New Mexico",
      "Grant - North Dakota",
      "Grant - Oklahoma",
      "Grant - Oregon",
      "Grant - South Dakota",
      "Grant - Washington",
      "Grant - West Virginia",
      "Grant - Wisconsin",
      "Grant Parish - Louisiana",
      "Granville - North Carolina",
      "Gratiot - Michigan",
      "Graves - Kentucky",
      "Gray - Kansas",
      "Gray - Texas",
      "Grays Harbor - Washington",
      "Grayson - Kentucky",
      "Grayson - Texas",
      "Grayson - Virginia",
      "Greeley - Kansas",
      "Greeley - Nebraska",
      "Green - Kentucky",
      "Green - Wisconsin",
      "Green Lake - Wisconsin",
      "Greenbrier - West Virginia",
      "Greene - Alabama",
      "Greene - Arkansas",
      "Greene - Georgia",
      "Greene - Illinois",
      "Greene - Indiana",
      "Greene - Iowa",
      "Greene - Mississippi",
      "Greene - Missouri",
      "Greene - New York",
      "Greene - North Carolina",
      "Greene - Ohio",
      "Greene - Pennsylvania",
      "Greene - Tennessee",
      "Greene - Virginia",
      "Greenlee - Arizona",
      "Greensville - Virginia",
      "Greenup - Kentucky",
      "Greenville - South Carolina",
      "Greenwood - Kansas",
      "Greenwood - South Carolina",
      "Greer - Oklahoma",
      "Gregg - Texas",
      "Gregory - South Dakota",
      "Grenada - Mississippi",
      "Griggs - North Dakota",
      "Grimes - Texas",
      "Grundy - Illinois",
      "Grundy - Iowa",
      "Grundy - Missouri",
      "Grundy - Tennessee",
      "Guadalupe - New Mexico",
      "Guadalupe - Texas",
      "Guam - Guam",
      "Guayama Municipio - Puerto Rico",
      "Guayanilla Municipio - Puerto Rico",
      "Guaynabo Municipio - Puerto Rico",
      "Guernsey - Ohio",
      "Guilford - North Carolina",
      "Gulf - Florida",
      "Gunnison - Colorado",
      "Gurabo Municipio - Puerto Rico",
      "Guthrie - Iowa",
      "Guánica Municipio - Puerto Rico",
      "Gwinnett - Georgia",
      "Haakon - South Dakota",
      "Habersham - Georgia",
      "Haines Borough - Alaska",
      "Hale - Alabama",
      "Hale - Texas",
      "Halifax - North Carolina",
      "Halifax - Virginia",
      "Hall - Georgia",
      "Hall - Nebraska",
      "Hall - Texas",
      "Hamblen - Tennessee",
      "Hamilton - Florida",
      "Hamilton - Illinois",
      "Hamilton - Indiana",
      "Hamilton - Iowa",
      "Hamilton - Kansas",
      "Hamilton - Nebraska",
      "Hamilton - New York",
      "Hamilton - Ohio",
      "Hamilton - Tennessee",
      "Hamilton - Texas",
      "Hamlin - South Dakota",
      "Hampden - Massachusetts",
      "Hampshire - Massachusetts",
      "Hampshire - West Virginia",
      "Hampton - South Carolina",
      "Hampton city - Virginia",
      "Hancock - Georgia",
      "Hancock - Illinois",
      "Hancock - Indiana",
      "Hancock - Iowa",
      "Hancock - Kentucky",
      "Hancock - Maine",
      "Hancock - Mississippi",
      "Hancock - Ohio",
      "Hancock - Tennessee",
      "Hancock - West Virginia",
      "Hand - South Dakota",
      "Hanover - Virginia",
      "Hansford - Texas",
      "Hanson - South Dakota",
      "Haralson - Georgia",
      "Hardee - Florida",
      "Hardeman - Tennessee",
      "Hardeman - Texas",
      "Hardin - Illinois",
      "Hardin - Iowa",
      "Hardin - Kentucky",
      "Hardin - Ohio",
      "Hardin - Tennessee",
      "Hardin - Texas",
      "Harding - New Mexico",
      "Harding - South Dakota",
      "Hardy - West Virginia",
      "Harford - Maryland",
      "Harlan - Kentucky",
      "Harlan - Nebraska",
      "Harmon - Oklahoma",
      "Harnett - North Carolina",
      "Harney - Oregon",
      "Harper - Kansas",
      "Harper - Oklahoma",
      "Harris - Georgia",
      "Harris - Texas",
      "Harrison - Indiana",
      "Harrison - Iowa",
      "Harrison - Kentucky",
      "Harrison - Mississippi",
      "Harrison - Missouri",
      "Harrison - Ohio",
      "Harrison - Texas",
      "Harrison - West Virginia",
      "Harrisonburg city - Virginia",
      "Hart - Georgia",
      "Hart - Kentucky",
      "Hartford - Connecticut",
      "Hartley - Texas",
      "Harvey - Kansas",
      "Haskell - Kansas",
      "Haskell - Oklahoma",
      "Haskell - Texas",
      "Hatillo Municipio - Puerto Rico",
      "Hawaii - Hawaii",
      "Hawkins - Tennessee",
      "Hayes - Nebraska",
      "Hays - Texas",
      "Haywood - North Carolina",
      "Haywood - Tennessee",
      "Heard - Georgia",
      "Hemphill - Texas",
      "Hempstead - Arkansas",
      "Henderson - Illinois",
      "Henderson - Kentucky",
      "Henderson - North Carolina",
      "Henderson - Tennessee",
      "Henderson - Texas",
      "Hendricks - Indiana",
      "Hendry - Florida",
      "Hennepin - Minnesota",
      "Henrico - Virginia",
      "Henry - Alabama",
      "Henry - Georgia",
      "Henry - Illinois",
      "Henry - Indiana",
      "Henry - Iowa",
      "Henry - Kentucky",
      "Henry - Missouri",
      "Henry - Ohio",
      "Henry - Tennessee",
      "Henry - Virginia",
      "Herkimer - New York",
      "Hernando - Florida",
      "Hertford - North Carolina",
      "Hettinger - North Dakota",
      "Hickman - Kentucky",
      "Hickman - Tennessee",
      "Hickory - Missouri",
      "Hidalgo - New Mexico",
      "Hidalgo - Texas",
      "Highland - Ohio",
      "Highland - Virginia",
      "Highlands - Florida",
      "Hill - Montana",
      "Hill - Texas",
      "Hillsborough - Florida",
      "Hillsborough - New Hampshire",
      "Hillsdale - Michigan",
      "Hinds - Mississippi",
      "Hinsdale - Colorado",
      "Hitchcock - Nebraska",
      "Hocking - Ohio",
      "Hockley - Texas",
      "Hodgeman - Kansas",
      "Hoke - North Carolina",
      "Holmes - Florida",
      "Holmes - Mississippi",
      "Holmes - Ohio",
      "Holt - Missouri",
      "Holt - Nebraska",
      "Honolulu - Hawaii",
      "Hood - Texas",
      "Hood River - Oregon",
      "Hooker - Nebraska",
      "Hoonah-Angoon Census Area - Alaska",
      "Hopewell city - Virginia",
      "Hopkins - Kentucky",
      "Hopkins - Texas",
      "Hormigueros Municipio - Puerto Rico",
      "Horry - South Carolina",
      "Hot Spring - Arkansas",
      "Hot Springs - Wyoming",
      "Houghton - Michigan",
      "Houston - Alabama",
      "Houston - Georgia",
      "Houston - Minnesota",
      "Houston - Tennessee",
      "Houston - Texas",
      "Howard - Arkansas",
      "Howard - Indiana",
      "Howard - Iowa",
      "Howard - Maryland",
      "Howard - Missouri",
      "Howard - Nebraska",
      "Howard - Texas",
      "Howell - Missouri",
      "Hubbard - Minnesota",
      "Hudson - New Jersey",
      "Hudspeth - Texas",
      "Huerfano - Colorado",
      "Hughes - Oklahoma",
      "Hughes - South Dakota",
      "Humacao Municipio - Puerto Rico",
      "Humboldt - California",
      "Humboldt - Iowa",
      "Humboldt - Nevada",
      "Humphreys - Mississippi",
      "Humphreys - Tennessee",
      "Hunt - Texas",
      "Hunterdon - New Jersey",
      "Huntingdon - Pennsylvania",
      "Huntington - Indiana",
      "Huron - Michigan",
      "Huron - Ohio",
      "Hutchinson - South Dakota",
      "Hutchinson - Texas",
      "Hyde - North Carolina",
      "Hyde - South Dakota",
      "Iberia Parish - Louisiana",
      "Iberville Parish - Louisiana",
      "Ida - Iowa",
      "Idaho - Idaho",
      "Imperial - California",
      "Independence - Arkansas",
      "Indian River - Florida",
      "Indiana - Pennsylvania",
      "Ingham - Michigan",
      "Inyo - California",
      "Ionia - Michigan",
      "Iosco - Michigan",
      "Iowa - Iowa",
      "Iowa - Wisconsin",
      "Iredell - North Carolina",
      "Irion - Texas",
      "Iron - Michigan",
      "Iron - Missouri",
      "Iron - Utah",
      "Iron - Wisconsin",
      "Iroquois - Illinois",
      "Irwin - Georgia",
      "Isabela Municipio - Puerto Rico",
      "Isabella - Michigan",
      "Isanti - Minnesota",
      "Island - Washington",
      "Isle of Wight - Virginia",
      "Issaquena - Mississippi",
      "Itasca - Minnesota",
      "Itawamba - Mississippi",
      "Izard - Arkansas",
      "Jack - Texas",
      "Jackson - Alabama",
      "Jackson - Arkansas",
      "Jackson - Colorado",
      "Jackson - Florida",
      "Jackson - Georgia",
      "Jackson - Illinois",
      "Jackson - Indiana",
      "Jackson - Iowa",
      "Jackson - Kansas",
      "Jackson - Kentucky",
      "Jackson - Michigan",
      "Jackson - Minnesota",
      "Jackson - Mississippi",
      "Jackson - Missouri",
      "Jackson - North Carolina",
      "Jackson - Ohio",
      "Jackson - Oklahoma",
      "Jackson - Oregon",
      "Jackson - South Dakota",
      "Jackson - Tennessee",
      "Jackson - Texas",
      "Jackson - West Virginia",
      "Jackson - Wisconsin",
      "Jackson Parish - Louisiana",
      "James City - Virginia",
      "Jasper - Georgia",
      "Jasper - Illinois",
      "Jasper - Indiana",
      "Jasper - Iowa",
      "Jasper - Mississippi",
      "Jasper - Missouri",
      "Jasper - South Carolina",
      "Jasper - Texas",
      "Jay - Indiana",
      "Jayuya Municipio - Puerto Rico",
      "Jeff Davis - Georgia",
      "Jeff Davis - Texas",
      "Jefferson - Alabama",
      "Jefferson - Arkansas",
      "Jefferson - Colorado",
      "Jefferson - Florida",
      "Jefferson - Georgia",
      "Jefferson - Idaho",
      "Jefferson - Illinois",
      "Jefferson - Indiana",
      "Jefferson - Iowa",
      "Jefferson - Kansas",
      "Jefferson - Kentucky",
      "Jefferson - Mississippi",
      "Jefferson - Missouri",
      "Jefferson - Montana",
      "Jefferson - Nebraska",
      "Jefferson - New York",
      "Jefferson - Ohio",
      "Jefferson - Oklahoma",
      "Jefferson - Oregon",
      "Jefferson - Pennsylvania",
      "Jefferson - Tennessee",
      "Jefferson - Texas",
      "Jefferson - Washington",
      "Jefferson - West Virginia",
      "Jefferson - Wisconsin",
      "Jefferson Davis - Mississippi",
      "Jefferson Davis Parish - Louisiana",
      "Jefferson Parish - Louisiana",
      "Jenkins - Georgia",
      "Jennings - Indiana",
      "Jerauld - South Dakota",
      "Jerome - Idaho",
      "Jersey - Illinois",
      "Jessamine - Kentucky",
      "Jewell - Kansas",
      "Jim Hogg - Texas",
      "Jim Wells - Texas",
      "Jo Daviess - Illinois",
      "Johnson - Arkansas",
      "Johnson - Georgia",
      "Johnson - Illinois",
      "Johnson - Indiana",
      "Johnson - Iowa",
      "Johnson - Kansas",
      "Johnson - Kentucky",
      "Johnson - Missouri",
      "Johnson - Nebraska",
      "Johnson - Tennessee",
      "Johnson - Texas",
      "Johnson - Wyoming",
      "Johnston - North Carolina",
      "Johnston - Oklahoma",
      "Jones - Georgia",
      "Jones - Iowa",
      "Jones - Mississippi",
      "Jones - North Carolina",
      "Jones - South Dakota",
      "Jones - Texas",
      "Josephine - Oregon",
      "Juab - Utah",
      "Juana Díaz Municipio - Puerto Rico",
      "Judith Basin - Montana",
      "Juncos Municipio - Puerto Rico",
      "Juneau - Wisconsin",
      "Juneau City and Borough - Alaska",
      "Juniata - Pennsylvania",
      "Kalamazoo - Michigan",
      "Kalawao - Hawaii",
      "Kalkaska - Michigan",
      "Kanabec - Minnesota",
      "Kanawha - West Virginia",
      "Kandiyohi - Minnesota",
      "Kane - Illinois",
      "Kane - Utah",
      "Kankakee - Illinois",
      "Karnes - Texas",
      "Kauai - Hawaii",
      "Kaufman - Texas",
      "Kay - Oklahoma",
      "Kearney - Nebraska",
      "Kearny - Kansas",
      "Keith - Nebraska",
      "Kemper - Mississippi",
      "Kenai Peninsula Borough - Alaska",
      "Kendall - Illinois",
      "Kendall - Texas",
      "Kenedy - Texas",
      "Kennebec - Maine",
      "Kenosha - Wisconsin",
      "Kent - Delaware",
      "Kent - Maryland",
      "Kent - Michigan",
      "Kent - Rhode Island",
      "Kent - Texas",
      "Kenton - Kentucky",
      "Keokuk - Iowa",
      "Kern - California",
      "Kerr - Texas",
      "Kershaw - South Carolina",
      "Ketchikan Gateway Borough - Alaska",
      "Kewaunee - Wisconsin",
      "Keweenaw - Michigan",
      "Keya Paha - Nebraska",
      "Kidder - North Dakota",
      "Kimball - Nebraska",
      "Kimble - Texas",
      "King - Texas",
      "King - Washington",
      "King George - Virginia",
      "King William - Virginia",
      "King and Queen - Virginia",
      "Kingfisher - Oklahoma",
      "Kingman - Kansas",
      "Kings - California",
      "Kings - New York",
      "Kingsbury - South Dakota",
      "Kinney - Texas",
      "Kiowa - Colorado",
      "Kiowa - Kansas",
      "Kiowa - Oklahoma",
      "Kit Carson - Colorado",
      "Kitsap - Washington",
      "Kittitas - Washington",
      "Kittson - Minnesota",
      "Klamath - Oregon",
      "Kleberg - Texas",
      "Klickitat - Washington",
      "Knott - Kentucky",
      "Knox - Illinois",
      "Knox - Indiana",
      "Knox - Kentucky",
      "Knox - Maine",
      "Knox - Missouri",
      "Knox - Nebraska",
      "Knox - Ohio",
      "Knox - Tennessee",
      "Knox - Texas",
      "Kodiak Island Borough - Alaska",
      "Koochiching - Minnesota",
      "Kootenai - Idaho",
      "Kosciusko - Indiana",
      "Kossuth - Iowa",
      "Kusilvak Census Area - Alaska",
      "La Crosse - Wisconsin",
      "La Paz - Arizona",
      "La Plata - Colorado",
      "La Salle - Texas",
      "LaGrange - Indiana",
      "LaMoure - North Dakota",
      "LaPorte - Indiana",
      "LaSalle - Illinois",
      "LaSalle Parish - Louisiana",
      "Labette - Kansas",
      "Lac qui Parle - Minnesota",
      "Lackawanna - Pennsylvania",
      "Laclede - Missouri",
      "Lafayette - Arkansas",
      "Lafayette - Florida",
      "Lafayette - Mississippi",
      "Lafayette - Missouri",
      "Lafayette - Wisconsin",
      "Lafayette Parish - Louisiana",
      "Lafourche Parish - Louisiana",
      "Lajas Municipio - Puerto Rico",
      "Lake - California",
      "Lake - Colorado",
      "Lake - Florida",
      "Lake - Illinois",
      "Lake - Indiana",
      "Lake - Michigan",
      "Lake - Minnesota",
      "Lake - Montana",
      "Lake - Ohio",
      "Lake - Oregon",
      "Lake - South Dakota",
      "Lake - Tennessee",
      "Lake and Peninsula Borough - Alaska",
      "Lake of the Woods - Minnesota",
      "Lamar - Alabama",
      "Lamar - Georgia",
      "Lamar - Mississippi",
      "Lamar - Texas",
      "Lamb - Texas",
      "Lamoille - Vermont",
      "Lampasas - Texas",
      "Lancaster - Nebraska",
      "Lancaster - Pennsylvania",
      "Lancaster - South Carolina",
      "Lancaster - Virginia",
      "Lander - Nevada",
      "Lane - Kansas",
      "Lane - Oregon",
      "Langlade - Wisconsin",
      "Lanier - Georgia",
      "Lapeer - Michigan",
      "Laramie - Wyoming",
      "Lares Municipio - Puerto Rico",
      "Larimer - Colorado",
      "Larue - Kentucky",
      "Las Animas - Colorado",
      "Las Marías Municipio - Puerto Rico",
      "Las Piedras Municipio - Puerto Rico",
      "Lassen - California",
      "Latah - Idaho",
      "Latimer - Oklahoma",
      "Lauderdale - Alabama",
      "Lauderdale - Mississippi",
      "Lauderdale - Tennessee",
      "Laurel - Kentucky",
      "Laurens - Georgia",
      "Laurens - South Carolina",
      "Lavaca - Texas",
      "Lawrence - Alabama",
      "Lawrence - Arkansas",
      "Lawrence - Illinois",
      "Lawrence - Indiana",
      "Lawrence - Kentucky",
      "Lawrence - Mississippi",
      "Lawrence - Missouri",
      "Lawrence - Ohio",
      "Lawrence - Pennsylvania",
      "Lawrence - South Dakota",
      "Lawrence - Tennessee",
      "Le Flore - Oklahoma",
      "Le Sueur - Minnesota",
      "Lea - New Mexico",
      "Leake - Mississippi",
      "Leavenworth - Kansas",
      "Lebanon - Pennsylvania",
      "Lee - Alabama",
      "Lee - Arkansas",
      "Lee - Florida",
      "Lee - Georgia",
      "Lee - Illinois",
      "Lee - Iowa",
      "Lee - Kentucky",
      "Lee - Mississippi",
      "Lee - North Carolina",
      "Lee - South Carolina",
      "Lee - Texas",
      "Lee - Virginia",
      "Leelanau - Michigan",
      "Leflore - Mississippi",
      "Lehigh - Pennsylvania",
      "Lemhi - Idaho",
      "Lenawee - Michigan",
      "Lenoir - North Carolina",
      "Leon - Florida",
      "Leon - Texas",
      "Leslie - Kentucky",
      "Letcher - Kentucky",
      "Levy - Florida",
      "Lewis - Idaho",
      "Lewis - Kentucky",
      "Lewis - Missouri",
      "Lewis - New York",
      "Lewis - Tennessee",
      "Lewis - Washington",
      "Lewis - West Virginia",
      "Lewis and Clark - Montana",
      "Lexington - South Carolina",
      "Lexington city - Virginia",
      "Liberty - Florida",
      "Liberty - Georgia",
      "Liberty - Montana",
      "Liberty - Texas",
      "Licking - Ohio",
      "Limestone - Alabama",
      "Limestone - Texas",
      "Lincoln - Arkansas",
      "Lincoln - Colorado",
      "Lincoln - Georgia",
      "Lincoln - Idaho",
      "Lincoln - Kansas",
      "Lincoln - Kentucky",
      "Lincoln - Maine",
      "Lincoln - Minnesota",
      "Lincoln - Mississippi",
      "Lincoln - Missouri",
      "Lincoln - Montana",
      "Lincoln - Nebraska",
      "Lincoln - Nevada",
      "Lincoln - New Mexico",
      "Lincoln - North Carolina",
      "Lincoln - Oklahoma",
      "Lincoln - Oregon",
      "Lincoln - South Dakota",
      "Lincoln - Tennessee",
      "Lincoln - Washington",
      "Lincoln - West Virginia",
      "Lincoln - Wisconsin",
      "Lincoln - Wyoming",
      "Lincoln Parish - Louisiana",
      "Linn - Iowa",
      "Linn - Kansas",
      "Linn - Missouri",
      "Linn - Oregon",
      "Lipscomb - Texas",
      "Litchfield - Connecticut",
      "Little River - Arkansas",
      "Live Oak - Texas",
      "Livingston - Illinois",
      "Livingston - Kentucky",
      "Livingston - Michigan",
      "Livingston - Missouri",
      "Livingston - New York",
      "Livingston Parish - Louisiana",
      "Llano - Texas",
      "Logan - Arkansas",
      "Logan - Colorado",
      "Logan - Illinois",
      "Logan - Kansas",
      "Logan - Kentucky",
      "Logan - Nebraska",
      "Logan - North Dakota",
      "Logan - Ohio",
      "Logan - Oklahoma",
      "Logan - West Virginia",
      "Long - Georgia",
      "Lonoke - Arkansas",
      "Lorain - Ohio",
      "Los Alamos - New Mexico",
      "Los Angeles - California",
      "Loudon - Tennessee",
      "Loudoun - Virginia",
      "Louisa - Iowa",
      "Louisa - Virginia",
      "Loup - Nebraska",
      "Love - Oklahoma",
      "Loving - Texas",
      "Lowndes - Alabama",
      "Lowndes - Georgia",
      "Lowndes - Mississippi",
      "Loíza Municipio - Puerto Rico",
      "Lubbock - Texas",
      "Lucas - Iowa",
      "Lucas - Ohio",
      "Luce - Michigan",
      "Lumpkin - Georgia",
      "Luna - New Mexico",
      "Lunenburg - Virginia",
      "Luquillo Municipio - Puerto Rico",
      "Luzerne - Pennsylvania",
      "Lycoming - Pennsylvania",
      "Lyman - South Dakota",
      "Lynchburg city - Virginia",
      "Lynn - Texas",
      "Lyon - Iowa",
      "Lyon - Kansas",
      "Lyon - Kentucky",
      "Lyon - Minnesota",
      "Lyon - Nevada",
      "Mackinac - Michigan",
      "Macomb - Michigan",
      "Macon - Alabama",
      "Macon - Georgia",
      "Macon - Illinois",
      "Macon - Missouri",
      "Macon - North Carolina",
      "Macon - Tennessee",
      "Macoupin - Illinois",
      "Madera - California",
      "Madison - Alabama",
      "Madison - Arkansas",
      "Madison - Florida",
      "Madison - Georgia",
      "Madison - Idaho",
      "Madison - Illinois",
      "Madison - Indiana",
      "Madison - Iowa",
      "Madison - Kentucky",
      "Madison - Mississippi",
      "Madison - Missouri",
      "Madison - Montana",
      "Madison - Nebraska",
      "Madison - New York",
      "Madison - North Carolina",
      "Madison - Ohio",
      "Madison - Tennessee",
      "Madison - Texas",
      "Madison - Virginia",
      "Madison Parish - Louisiana",
      "Magoffin - Kentucky",
      "Mahaska - Iowa",
      "Mahnomen - Minnesota",
      "Mahoning - Ohio",
      "Major - Oklahoma",
      "Malheur - Oregon",
      "Manassas Park city - Virginia",
      "Manassas city - Virginia",
      "Manatee - Florida",
      "Manatí Municipio - Puerto Rico",
      "Manistee - Michigan",
      "Manitowoc - Wisconsin",
      "Manu'a District - American Samoa",
      "Marathon - Wisconsin",
      "Marengo - Alabama",
      "Maricao Municipio - Puerto Rico",
      "Maricopa - Arizona",
      "Maries - Missouri",
      "Marin - California",
      "Marinette - Wisconsin",
      "Marion - Alabama",
      "Marion - Arkansas",
      "Marion - Florida",
      "Marion - Georgia",
      "Marion - Illinois",
      "Marion - Indiana",
      "Marion - Iowa",
      "Marion - Kansas",
      "Marion - Kentucky",
      "Marion - Mississippi",
      "Marion - Missouri",
      "Marion - Ohio",
      "Marion - Oregon",
      "Marion - South Carolina",
      "Marion - Tennessee",
      "Marion - Texas",
      "Marion - West Virginia",
      "Mariposa - California",
      "Marlboro - South Carolina",
      "Marquette - Michigan",
      "Marquette - Wisconsin",
      "Marshall - Alabama",
      "Marshall - Illinois",
      "Marshall - Indiana",
      "Marshall - Iowa",
      "Marshall - Kansas",
      "Marshall - Kentucky",
      "Marshall - Minnesota",
      "Marshall - Mississippi",
      "Marshall - Oklahoma",
      "Marshall - South Dakota",
      "Marshall - Tennessee",
      "Marshall - West Virginia",
      "Martin - Florida",
      "Martin - Indiana",
      "Martin - Kentucky",
      "Martin - Minnesota",
      "Martin - North Carolina",
      "Martin - Texas",
      "Martinsville city - Virginia",
      "Mason - Illinois",
      "Mason - Kentucky",
      "Mason - Michigan",
      "Mason - Texas",
      "Mason - Washington",
      "Mason - West Virginia",
      "Massac - Illinois",
      "Matagorda - Texas",
      "Matanuska-Susitna Borough - Alaska",
      "Mathews - Virginia",
      "Maui - Hawaii",
      "Maunabo Municipio - Puerto Rico",
      "Maury - Tennessee",
      "Maverick - Texas",
      "Mayagüez Municipio - Puerto Rico",
      "Mayes - Oklahoma",
      "McClain - Oklahoma",
      "McCone - Montana",
      "McCook - South Dakota",
      "McCormick - South Carolina",
      "McCracken - Kentucky",
      "McCreary - Kentucky",
      "McCulloch - Texas",
      "McCurtain - Oklahoma",
      "McDonald - Missouri",
      "McDonough - Illinois",
      "McDowell - North Carolina",
      "McDowell - West Virginia",
      "McDuffie - Georgia",
      "McHenry - Illinois",
      "McHenry - North Dakota",
      "McIntosh - Georgia",
      "McIntosh - North Dakota",
      "McIntosh - Oklahoma",
      "McKean - Pennsylvania",
      "McKenzie - North Dakota",
      "McKinley - New Mexico",
      "McLean - Illinois",
      "McLean - Kentucky",
      "McLean - North Dakota",
      "McLennan - Texas",
      "McLeod - Minnesota",
      "McMinn - Tennessee",
      "McMullen - Texas",
      "McNairy - Tennessee",
      "McPherson - Kansas",
      "McPherson - Nebraska",
      "McPherson - South Dakota",
      "Meade - Kansas",
      "Meade - Kentucky",
      "Meade - South Dakota",
      "Meagher - Montana",
      "Mecklenburg - North Carolina",
      "Mecklenburg - Virginia",
      "Mecosta - Michigan",
      "Medina - Ohio",
      "Medina - Texas",
      "Meeker - Minnesota",
      "Meigs - Ohio",
      "Meigs - Tennessee",
      "Mellette - South Dakota",
      "Menard - Illinois",
      "Menard - Texas",
      "Mendocino - California",
      "Menifee - Kentucky",
      "Menominee - Michigan",
      "Menominee - Wisconsin",
      "Merced - California",
      "Mercer - Illinois",
      "Mercer - Kentucky",
      "Mercer - Missouri",
      "Mercer - New Jersey",
      "Mercer - North Dakota",
      "Mercer - Ohio",
      "Mercer - Pennsylvania",
      "Mercer - West Virginia",
      "Meriwether - Georgia",
      "Merrick - Nebraska",
      "Merrimack - New Hampshire",
      "Mesa - Colorado",
      "Metcalfe - Kentucky",
      "Miami - Indiana",
      "Miami - Kansas",
      "Miami - Ohio",
      "Miami-Dade - Florida",
      "Middlesex - Connecticut",
      "Middlesex - Massachusetts",
      "Middlesex - New Jersey",
      "Middlesex - Virginia",
      "Midland - Michigan",
      "Midland - Texas",
      "Mifflin - Pennsylvania",
      "Milam - Texas",
      "Millard - Utah",
      "Mille Lacs - Minnesota",
      "Miller - Arkansas",
      "Miller - Georgia",
      "Miller - Missouri",
      "Mills - Iowa",
      "Mills - Texas",
      "Milwaukee - Wisconsin",
      "Miner - South Dakota",
      "Mineral - Colorado",
      "Mineral - Montana",
      "Mineral - Nevada",
      "Mineral - West Virginia",
      "Mingo - West Virginia",
      "Minidoka - Idaho",
      "Minnehaha - South Dakota",
      "Missaukee - Michigan",
      "Mississippi - Arkansas",
      "Mississippi - Missouri",
      "Missoula - Montana",
      "Mitchell - Georgia",
      "Mitchell - Iowa",
      "Mitchell - Kansas",
      "Mitchell - North Carolina",
      "Mitchell - Texas",
      "Mobile - Alabama",
      "Moca Municipio - Puerto Rico",
      "Modoc - California",
      "Moffat - Colorado",
      "Mohave - Arizona",
      "Moniteau - Missouri",
      "Monmouth - New Jersey",
      "Mono - California",
      "Monona - Iowa",
      "Monongalia - West Virginia",
      "Monroe - Alabama",
      "Monroe - Arkansas",
      "Monroe - Florida",
      "Monroe - Georgia",
      "Monroe - Illinois",
      "Monroe - Indiana",
      "Monroe - Iowa",
      "Monroe - Kentucky",
      "Monroe - Michigan",
      "Monroe - Mississippi",
      "Monroe - Missouri",
      "Monroe - New York",
      "Monroe - Ohio",
      "Monroe - Pennsylvania",
      "Monroe - Tennessee",
      "Monroe - West Virginia",
      "Monroe - Wisconsin",
      "Montague - Texas",
      "Montcalm - Michigan",
      "Monterey - California",
      "Montezuma - Colorado",
      "Montgomery - Alabama",
      "Montgomery - Arkansas",
      "Montgomery - Georgia",
      "Montgomery - Illinois",
      "Montgomery - Indiana",
      "Montgomery - Iowa",
      "Montgomery - Kansas",
      "Montgomery - Kentucky",
      "Montgomery - Maryland",
      "Montgomery - Mississippi",
      "Montgomery - Missouri",
      "Montgomery - New York",
      "Montgomery - North Carolina",
      "Montgomery - Ohio",
      "Montgomery - Pennsylvania",
      "Montgomery - Tennessee",
      "Montgomery - Texas",
      "Montgomery - Virginia",
      "Montmorency - Michigan",
      "Montour - Pennsylvania",
      "Montrose - Colorado",
      "Moody - South Dakota",
      "Moore - North Carolina",
      "Moore - Tennessee",
      "Moore - Texas",
      "Mora - New Mexico",
      "Morehouse Parish - Louisiana",
      "Morgan - Alabama",
      "Morgan - Colorado",
      "Morgan - Georgia",
      "Morgan - Illinois",
      "Morgan - Indiana",
      "Morgan - Kentucky",
      "Morgan - Missouri",
      "Morgan - Ohio",
      "Morgan - Tennessee",
      "Morgan - Utah",
      "Morgan - West Virginia",
      "Morovis Municipio - Puerto Rico",
      "Morrill - Nebraska",
      "Morris - Kansas",
      "Morris - New Jersey",
      "Morris - Texas",
      "Morrison - Minnesota",
      "Morrow - Ohio",
      "Morrow - Oregon",
      "Morton - Kansas",
      "Morton - North Dakota",
      "Motley - Texas",
      "Moultrie - Illinois",
      "Mountrail - North Dakota",
      "Mower - Minnesota",
      "Muhlenberg - Kentucky",
      "Multnomah - Oregon",
      "Murray - Georgia",
      "Murray - Minnesota",
      "Murray - Oklahoma",
      "Muscatine - Iowa",
      "Muscogee - Georgia",
      "Muskegon - Michigan",
      "Muskingum - Ohio",
      "Muskogee - Oklahoma",
      "Musselshell - Montana",
      "Nacogdoches - Texas",
      "Naguabo Municipio - Puerto Rico",
      "Nance - Nebraska",
      "Nantucket - Massachusetts",
      "Napa - California",
      "Naranjito Municipio - Puerto Rico",
      "Nash - North Carolina",
      "Nassau - Florida",
      "Nassau - New York",
      "Natchitoches Parish - Louisiana",
      "Natrona - Wyoming",
      "Navajo - Arizona",
      "Navarro - Texas",
      "Nelson - Kentucky",
      "Nelson - North Dakota",
      "Nelson - Virginia",
      "Nemaha - Kansas",
      "Nemaha - Nebraska",
      "Neosho - Kansas",
      "Neshoba - Mississippi",
      "Ness - Kansas",
      "Nevada - Arkansas",
      "Nevada - California",
      "New Castle - Delaware",
      "New Hanover - North Carolina",
      "New Haven - Connecticut",
      "New Kent - Virginia",
      "New London - Connecticut",
      "New Madrid - Missouri",
      "New York - New York",
      "Newaygo - Michigan",
      "Newberry - South Carolina",
      "Newport - Rhode Island",
      "Newport News city - Virginia",
      "Newton - Arkansas",
      "Newton - Georgia",
      "Newton - Indiana",
      "Newton - Mississippi",
      "Newton - Missouri",
      "Newton - Texas",
      "Nez Perce - Idaho",
      "Niagara - New York",
      "Nicholas - Kentucky",
      "Nicholas - West Virginia",
      "Nicollet - Minnesota",
      "Niobrara - Wyoming",
      "Noble - Indiana",
      "Noble - Ohio",
      "Noble - Oklahoma",
      "Nobles - Minnesota",
      "Nodaway - Missouri",
      "Nolan - Texas",
      "Nome Census Area - Alaska",
      "Norfolk - Massachusetts",
      "Norfolk city - Virginia",
      "Norman - Minnesota",
      "North Slope Borough - Alaska",
      "Northampton - North Carolina",
      "Northampton - Pennsylvania",
      "Northampton - Virginia",
      "Northern Islands Municipality - Commonwealth of the Northern Mariana Islands",
      "Northumberland - Pennsylvania",
      "Northumberland - Virginia",
      "Northwest Arctic Borough - Alaska",
      "Norton - Kansas",
      "Norton city - Virginia",
      "Nottoway - Virginia",
      "Nowata - Oklahoma",
      "Noxubee - Mississippi",
      "Nuckolls - Nebraska",
      "Nueces - Texas",
      "Nye - Nevada",
      "O'Brien - Iowa",
      "Oakland - Michigan",
      "Obion - Tennessee",
      "Ocean - New Jersey",
      "Oceana - Michigan",
      "Ochiltree - Texas",
      "Oconee - Georgia",
      "Oconee - South Carolina",
      "Oconto - Wisconsin",
      "Ogemaw - Michigan",
      "Oglala Lakota - South Dakota",
      "Ogle - Illinois",
      "Oglethorpe - Georgia",
      "Ohio - Indiana",
      "Ohio - Kentucky",
      "Ohio - West Virginia",
      "Okaloosa - Florida",
      "Okanogan - Washington",
      "Okeechobee - Florida",
      "Okfuskee - Oklahoma",
      "Oklahoma - Oklahoma",
      "Okmulgee - Oklahoma",
      "Oktibbeha - Mississippi",
      "Oldham - Kentucky",
      "Oldham - Texas",
      "Oliver - North Dakota",
      "Olmsted - Minnesota",
      "Oneida - Idaho",
      "Oneida - New York",
      "Oneida - Wisconsin",
      "Onondaga - New York",
      "Onslow - North Carolina",
      "Ontario - New York",
      "Ontonagon - Michigan",
      "Orange - California",
      "Orange - Florida",
      "Orange - Indiana",
      "Orange - New York",
      "Orange - North Carolina",
      "Orange - Texas",
      "Orange - Vermont",
      "Orange - Virginia",
      "Orangeburg - South Carolina",
      "Oregon - Missouri",
      "Orleans - New York",
      "Orleans - Vermont",
      "Orleans Parish - Louisiana",
      "Orocovis Municipio - Puerto Rico",
      "Osage - Kansas",
      "Osage - Missouri",
      "Osage - Oklahoma",
      "Osborne - Kansas",
      "Osceola - Florida",
      "Osceola - Iowa",
      "Osceola - Michigan",
      "Oscoda - Michigan",
      "Oswego - New York",
      "Otero - Colorado",
      "Otero - New Mexico",
      "Otoe - Nebraska",
      "Otsego - Michigan",
      "Otsego - New York",
      "Ottawa - Kansas",
      "Ottawa - Michigan",
      "Ottawa - Ohio",
      "Ottawa - Oklahoma",
      "Otter Tail - Minnesota",
      "Ouachita - Arkansas",
      "Ouachita Parish - Louisiana",
      "Ouray - Colorado",
      "Outagamie - Wisconsin",
      "Overton - Tennessee",
      "Owen - Indiana",
      "Owen - Kentucky",
      "Owsley - Kentucky",
      "Owyhee - Idaho",
      "Oxford - Maine",
      "Ozark - Missouri",
      "Ozaukee - Wisconsin",
      "Pacific - Washington",
      "Page - Iowa",
      "Page - Virginia",
      "Palm Beach - Florida",
      "Palo Alto - Iowa",
      "Palo Pinto - Texas",
      "Pamlico - North Carolina",
      "Panola - Mississippi",
      "Panola - Texas",
      "Park - Colorado",
      "Park - Montana",
      "Park - Wyoming",
      "Parke - Indiana",
      "Parker - Texas",
      "Parmer - Texas",
      "Pasco - Florida",
      "Pasquotank - North Carolina",
      "Passaic - New Jersey",
      "Patillas Municipio - Puerto Rico",
      "Patrick - Virginia",
      "Paulding - Georgia",
      "Paulding - Ohio",
      "Pawnee - Kansas",
      "Pawnee - Nebraska",
      "Pawnee - Oklahoma",
      "Payette - Idaho",
      "Payne - Oklahoma",
      "Peach - Georgia",
      "Pearl River - Mississippi",
      "Pecos - Texas",
      "Pembina - North Dakota",
      "Pemiscot - Missouri",
      "Pend Oreille - Washington",
      "Pender - North Carolina",
      "Pendleton - Kentucky",
      "Pendleton - West Virginia",
      "Pennington - Minnesota",
      "Pennington - South Dakota",
      "Penobscot - Maine",
      "Peoria - Illinois",
      "Pepin - Wisconsin",
      "Perkins - Nebraska",
      "Perkins - South Dakota",
      "Perquimans - North Carolina",
      "Perry - Alabama",
      "Perry - Arkansas",
      "Perry - Illinois",
      "Perry - Indiana",
      "Perry - Kentucky",
      "Perry - Mississippi",
      "Perry - Missouri",
      "Perry - Ohio",
      "Perry - Pennsylvania",
      "Perry - Tennessee",
      "Pershing - Nevada",
      "Person - North Carolina",
      "Petersburg Borough - Alaska",
      "Petersburg city - Virginia",
      "Petroleum - Montana",
      "Pettis - Missouri",
      "Peñuelas Municipio - Puerto Rico",
      "Phelps - Missouri",
      "Phelps - Nebraska",
      "Philadelphia - Pennsylvania",
      "Phillips - Arkansas",
      "Phillips - Colorado",
      "Phillips - Kansas",
      "Phillips - Montana",
      "Piatt - Illinois",
      "Pickaway - Ohio",
      "Pickens - Alabama",
      "Pickens - Georgia",
      "Pickens - South Carolina",
      "Pickett - Tennessee",
      "Pierce - Georgia",
      "Pierce - Nebraska",
      "Pierce - North Dakota",
      "Pierce - Washington",
      "Pierce - Wisconsin",
      "Pike - Alabama",
      "Pike - Arkansas",
      "Pike - Georgia",
      "Pike - Illinois",
      "Pike - Indiana",
      "Pike - Kentucky",
      "Pike - Mississippi",
      "Pike - Missouri",
      "Pike - Ohio",
      "Pike - Pennsylvania",
      "Pima - Arizona",
      "Pinal - Arizona",
      "Pine - Minnesota",
      "Pinellas - Florida",
      "Pipestone - Minnesota",
      "Piscataquis - Maine",
      "Pitkin - Colorado",
      "Pitt - North Carolina",
      "Pittsburg - Oklahoma",
      "Pittsylvania - Virginia",
      "Piute - Utah",
      "Placer - California",
      "Plaquemines Parish - Louisiana",
      "Platte - Missouri",
      "Platte - Nebraska",
      "Platte - Wyoming",
      "Pleasants - West Virginia",
      "Plumas - California",
      "Plymouth - Iowa",
      "Plymouth - Massachusetts",
      "Pocahontas - Iowa",
      "Pocahontas - West Virginia",
      "Poinsett - Arkansas",
      "Pointe Coupee Parish - Louisiana",
      "Polk - Arkansas",
      "Polk - Florida",
      "Polk - Georgia",
      "Polk - Iowa",
      "Polk - Minnesota",
      "Polk - Missouri",
      "Polk - Nebraska",
      "Polk - North Carolina",
      "Polk - Oregon",
      "Polk - Tennessee",
      "Polk - Texas",
      "Polk - Wisconsin",
      "Ponce Municipio - Puerto Rico",
      "Pondera - Montana",
      "Pontotoc - Mississippi",
      "Pontotoc - Oklahoma",
      "Pope - Arkansas",
      "Pope - Illinois",
      "Pope - Minnesota",
      "Poquoson city - Virginia",
      "Portage - Ohio",
      "Portage - Wisconsin",
      "Porter - Indiana",
      "Portsmouth city - Virginia",
      "Posey - Indiana",
      "Pottawatomie - Kansas",
      "Pottawatomie - Oklahoma",
      "Pottawattamie - Iowa",
      "Potter - Pennsylvania",
      "Potter - South Dakota",
      "Potter - Texas",
      "Powder River - Montana",
      "Powell - Kentucky",
      "Powell - Montana",
      "Power - Idaho",
      "Poweshiek - Iowa",
      "Powhatan - Virginia",
      "Prairie - Arkansas",
      "Prairie - Montana",
      "Pratt - Kansas",
      "Preble - Ohio",
      "Prentiss - Mississippi",
      "Presidio - Texas",
      "Presque Isle - Michigan",
      "Preston - West Virginia",
      "Price - Wisconsin",
      "Prince Edward - Virginia",
      "Prince George - Virginia",
      "Prince George's - Maryland",
      "Prince William - Virginia",
      "Prince of Wales-Hyder Census Area - Alaska",
      "Providence - Rhode Island",
      "Prowers - Colorado",
      "Pueblo - Colorado",
      "Pulaski - Arkansas",
      "Pulaski - Georgia",
      "Pulaski - Illinois",
      "Pulaski - Indiana",
      "Pulaski - Kentucky",
      "Pulaski - Missouri",
      "Pulaski - Virginia",
      "Pushmataha - Oklahoma",
      "Putnam - Florida",
      "Putnam - Georgia",
      "Putnam - Illinois",
      "Putnam - Indiana",
      "Putnam - Missouri",
      "Putnam - New York",
      "Putnam - Ohio",
      "Putnam - Tennessee",
      "Putnam - West Virginia",
      "Quay - New Mexico",
      "Quebradillas Municipio - Puerto Rico",
      "Queen Anne's - Maryland",
      "Queens - New York",
      "Quitman - Georgia",
      "Quitman - Mississippi",
      "Rabun - Georgia",
      "Racine - Wisconsin",
      "Radford city - Virginia",
      "Rains - Texas",
      "Raleigh - West Virginia",
      "Ralls - Missouri",
      "Ramsey - Minnesota",
      "Ramsey - North Dakota",
      "Randall - Texas",
      "Randolph - Alabama",
      "Randolph - Arkansas",
      "Randolph - Georgia",
      "Randolph - Illinois",
      "Randolph - Indiana",
      "Randolph - Missouri",
      "Randolph - North Carolina",
      "Randolph - West Virginia",
      "Rankin - Mississippi",
      "Ransom - North Dakota",
      "Rapides Parish - Louisiana",
      "Rappahannock - Virginia",
      "Ravalli - Montana",
      "Rawlins - Kansas",
      "Ray - Missouri",
      "Reagan - Texas",
      "Real - Texas",
      "Red Lake - Minnesota",
      "Red River - Texas",
      "Red River Parish - Louisiana",
      "Red Willow - Nebraska",
      "Redwood - Minnesota",
      "Reeves - Texas",
      "Refugio - Texas",
      "Reno - Kansas",
      "Rensselaer - New York",
      "Renville - Minnesota",
      "Renville - North Dakota",
      "Republic - Kansas",
      "Reynolds - Missouri",
      "Rhea - Tennessee",
      "Rice - Kansas",
      "Rice - Minnesota",
      "Rich - Utah",
      "Richardson - Nebraska",
      "Richland - Illinois",
      "Richland - Montana",
      "Richland - North Dakota",
      "Richland - Ohio",
      "Richland - South Carolina",
      "Richland - Wisconsin",
      "Richland Parish - Louisiana",
      "Richmond - Georgia",
      "Richmond - New York",
      "Richmond - North Carolina",
      "Richmond - Virginia",
      "Richmond city - Virginia",
      "Riley - Kansas",
      "Rincón Municipio - Puerto Rico",
      "Ringgold - Iowa",
      "Rio Arriba - New Mexico",
      "Rio Blanco - Colorado",
      "Rio Grande - Colorado",
      "Ripley - Indiana",
      "Ripley - Missouri",
      "Ritchie - West Virginia",
      "Riverside - California",
      "Roane - Tennessee",
      "Roane - West Virginia",
      "Roanoke - Virginia",
      "Roanoke city - Virginia",
      "Roberts - South Dakota",
      "Roberts - Texas",
      "Robertson - Kentucky",
      "Robertson - Tennessee",
      "Robertson - Texas",
      "Robeson - North Carolina",
      "Rock - Minnesota",
      "Rock - Nebraska",
      "Rock - Wisconsin",
      "Rock Island - Illinois",
      "Rockbridge - Virginia",
      "Rockcastle - Kentucky",
      "Rockdale - Georgia",
      "Rockingham - New Hampshire",
      "Rockingham - North Carolina",
      "Rockingham - Virginia",
      "Rockland - New York",
      "Rockwall - Texas",
      "Roger Mills - Oklahoma",
      "Rogers - Oklahoma",
      "Rolette - North Dakota",
      "Rooks - Kansas",
      "Roosevelt - Montana",
      "Roosevelt - New Mexico",
      "Roscommon - Michigan",
      "Rose Island - American Samoa",
      "Roseau - Minnesota",
      "Rosebud - Montana",
      "Ross - Ohio",
      "Rota Municipality - Commonwealth of the Northern Mariana Islands",
      "Routt - Colorado",
      "Rowan - Kentucky",
      "Rowan - North Carolina",
      "Runnels - Texas",
      "Rush - Indiana",
      "Rush - Kansas",
      "Rusk - Texas",
      "Rusk - Wisconsin",
      "Russell - Alabama",
      "Russell - Kansas",
      "Russell - Kentucky",
      "Russell - Virginia",
      "Rutherford - North Carolina",
      "Rutherford - Tennessee",
      "Rutland - Vermont",
      "Río Grande Municipio - Puerto Rico",
      "Sabana Grande Municipio - Puerto Rico",
      "Sabine - Texas",
      "Sabine Parish - Louisiana",
      "Sac - Iowa",
      "Sacramento - California",
      "Sagadahoc - Maine",
      "Saginaw - Michigan",
      "Saguache - Colorado",
      "Saipan Municipality - Commonwealth of the Northern Mariana Islands",
      "Salem - New Jersey",
      "Salem city - Virginia",
      "Salinas Municipio - Puerto Rico",
      "Saline - Arkansas",
      "Saline - Illinois",
      "Saline - Kansas",
      "Saline - Missouri",
      "Saline - Nebraska",
      "Salt Lake - Utah",
      "Saluda - South Carolina",
      "Sampson - North Carolina",
      "San Augustine - Texas",
      "San Benito - California",
      "San Bernardino - California",
      "San Diego - California",
      "San Francisco - California",
      "San Germán Municipio - Puerto Rico",
      "San Jacinto - Texas",
      "San Joaquin - California",
      "San Juan - Colorado",
      "San Juan - New Mexico",
      "San Juan - Utah",
      "San Juan - Washington",
      "San Juan Municipio - Puerto Rico",
      "San Lorenzo Municipio - Puerto Rico",
      "San Luis Obispo - California",
      "San Mateo - California",
      "San Miguel - Colorado",
      "San Miguel - New Mexico",
      "San Patricio - Texas",
      "San Saba - Texas",
      "San Sebastián Municipio - Puerto Rico",
      "Sanborn - South Dakota",
      "Sanders - Montana",
      "Sandoval - New Mexico",
      "Sandusky - Ohio",
      "Sangamon - Illinois",
      "Sanilac - Michigan",
      "Sanpete - Utah",
      "Santa Barbara - California",
      "Santa Clara - California",
      "Santa Cruz - Arizona",
      "Santa Cruz - California",
      "Santa Fe - New Mexico",
      "Santa Isabel Municipio - Puerto Rico",
      "Santa Rosa - Florida",
      "Sarasota - Florida",
      "Saratoga - New York",
      "Sargent - North Dakota",
      "Sarpy - Nebraska",
      "Sauk - Wisconsin",
      "Saunders - Nebraska",
      "Sawyer - Wisconsin",
      "Schenectady - New York",
      "Schleicher - Texas",
      "Schley - Georgia",
      "Schoharie - New York",
      "Schoolcraft - Michigan",
      "Schuyler - Illinois",
      "Schuyler - Missouri",
      "Schuyler - New York",
      "Schuylkill - Pennsylvania",
      "Scioto - Ohio",
      "Scotland - Missouri",
      "Scotland - North Carolina",
      "Scott - Arkansas",
      "Scott - Illinois",
      "Scott - Indiana",
      "Scott - Iowa",
      "Scott - Kansas",
      "Scott - Kentucky",
      "Scott - Minnesota",
      "Scott - Mississippi",
      "Scott - Missouri",
      "Scott - Tennessee",
      "Scott - Virginia",
      "Scotts Bluff - Nebraska",
      "Screven - Georgia",
      "Scurry - Texas",
      "Searcy - Arkansas",
      "Sebastian - Arkansas",
      "Sedgwick - Colorado",
      "Sedgwick - Kansas",
      "Seminole - Florida",
      "Seminole - Georgia",
      "Seminole - Oklahoma",
      "Seneca - New York",
      "Seneca - Ohio",
      "Sequatchie - Tennessee",
      "Sequoyah - Oklahoma",
      "Sevier - Arkansas",
      "Sevier - Tennessee",
      "Sevier - Utah",
      "Seward - Kansas",
      "Seward - Nebraska",
      "Shackelford - Texas",
      "Shannon - Missouri",
      "Sharkey - Mississippi",
      "Sharp - Arkansas",
      "Shasta - California",
      "Shawano - Wisconsin",
      "Shawnee - Kansas",
      "Sheboygan - Wisconsin",
      "Shelby - Alabama",
      "Shelby - Illinois",
      "Shelby - Indiana",
      "Shelby - Iowa",
      "Shelby - Kentucky",
      "Shelby - Missouri",
      "Shelby - Ohio",
      "Shelby - Tennessee",
      "Shelby - Texas",
      "Shenandoah - Virginia",
      "Sherburne - Minnesota",
      "Sheridan - Kansas",
      "Sheridan - Montana",
      "Sheridan - Nebraska",
      "Sheridan - North Dakota",
      "Sheridan - Wyoming",
      "Sherman - Kansas",
      "Sherman - Nebraska",
      "Sherman - Oregon",
      "Sherman - Texas",
      "Shiawassee - Michigan",
      "Shoshone - Idaho",
      "Sibley - Minnesota",
      "Sierra - California",
      "Sierra - New Mexico",
      "Silver Bow - Montana",
      "Simpson - Kentucky",
      "Simpson - Mississippi",
      "Sioux - Iowa",
      "Sioux - Nebraska",
      "Sioux - North Dakota",
      "Siskiyou - California",
      "Sitka City and Borough - Alaska",
      "Skagit - Washington",
      "Skagway Municipality - Alaska",
      "Skamania - Washington",
      "Slope - North Dakota",
      "Smith - Kansas",
      "Smith - Mississippi",
      "Smith - Tennessee",
      "Smith - Texas",
      "Smyth - Virginia",
      "Snohomish - Washington",
      "Snyder - Pennsylvania",
      "Socorro - New Mexico",
      "Solano - California",
      "Somerset - Maine",
      "Somerset - Maryland",
      "Somerset - New Jersey",
      "Somerset - Pennsylvania",
      "Somervell - Texas",
      "Sonoma - California",
      "Southampton - Virginia",
      "Southeast Fairbanks Census Area - Alaska",
      "Spalding - Georgia",
      "Spartanburg - South Carolina",
      "Spencer - Indiana",
      "Spencer - Kentucky",
      "Spink - South Dakota",
      "Spokane - Washington",
      "Spotsylvania - Virginia",
      "St. Bernard Parish - Louisiana",
      "St. Charles - Missouri",
      "St. Charles Parish - Louisiana",
      "St. Clair - Alabama",
      "St. Clair - Illinois",
      "St. Clair - Michigan",
      "St. Clair - Missouri",
      "St. Croix - Wisconsin",
      "St. Croix Island - United States Virgin Islands",
      "St. Francis - Arkansas",
      "St. Francois - Missouri",
      "St. Helena Parish - Louisiana",
      "St. James Parish - Louisiana",
      "St. John Island - United States Virgin Islands",
      "St. John the Baptist Parish - Louisiana",
      "St. Johns - Florida",
      "St. Joseph - Indiana",
      "St. Joseph - Michigan",
      "St. Landry Parish - Louisiana",
      "St. Lawrence - New York",
      "St. Louis - Minnesota",
      "St. Louis - Missouri",
      "St. Louis city - Missouri",
      "St. Lucie - Florida",
      "St. Martin Parish - Louisiana",
      "St. Mary Parish - Louisiana",
      "St. Mary's - Maryland",
      "St. Tammany Parish - Louisiana",
      "St. Thomas Island - United States Virgin Islands",
      "Stafford - Kansas",
      "Stafford - Virginia",
      "Stanislaus - California",
      "Stanley - South Dakota",
      "Stanly - North Carolina",
      "Stanton - Kansas",
      "Stanton - Nebraska",
      "Stark - Illinois",
      "Stark - North Dakota",
      "Stark - Ohio",
      "Starke - Indiana",
      "Starr - Texas",
      "Staunton city - Virginia",
      "Ste. Genevieve - Missouri",
      "Stearns - Minnesota",
      "Steele - Minnesota",
      "Steele - North Dakota",
      "Stephens - Georgia",
      "Stephens - Oklahoma",
      "Stephens - Texas",
      "Stephenson - Illinois",
      "Sterling - Texas",
      "Steuben - Indiana",
      "Steuben - New York",
      "Stevens - Kansas",
      "Stevens - Minnesota",
      "Stevens - Washington",
      "Stewart - Georgia",
      "Stewart - Tennessee",
      "Stillwater - Montana",
      "Stoddard - Missouri",
      "Stokes - North Carolina",
      "Stone - Arkansas",
      "Stone - Mississippi",
      "Stone - Missouri",
      "Stonewall - Texas",
      "Storey - Nevada",
      "Story - Iowa",
      "Strafford - New Hampshire",
      "Stutsman - North Dakota",
      "Sublette - Wyoming",
      "Suffolk - Massachusetts",
      "Suffolk - New York",
      "Suffolk city - Virginia",
      "Sullivan - Indiana",
      "Sullivan - Missouri",
      "Sullivan - New Hampshire",
      "Sullivan - New York",
      "Sullivan - Pennsylvania",
      "Sullivan - Tennessee",
      "Sully - South Dakota",
      "Summers - West Virginia",
      "Summit - Colorado",
      "Summit - Ohio",
      "Summit - Utah",
      "Sumner - Kansas",
      "Sumner - Tennessee",
      "Sumter - Alabama",
      "Sumter - Florida",
      "Sumter - Georgia",
      "Sumter - South Carolina",
      "Sunflower - Mississippi",
      "Surry - North Carolina",
      "Surry - Virginia",
      "Susquehanna - Pennsylvania",
      "Sussex - Delaware",
      "Sussex - New Jersey",
      "Sussex - Virginia",
      "Sutter - California",
      "Sutton - Texas",
      "Suwannee - Florida",
      "Swain - North Carolina",
      "Swains Island - American Samoa",
      "Sweet Grass - Montana",
      "Sweetwater - Wyoming",
      "Swift - Minnesota",
      "Swisher - Texas",
      "Switzerland - Indiana",
      "Talbot - Georgia",
      "Talbot - Maryland",
      "Taliaferro - Georgia",
      "Talladega - Alabama",
      "Tallahatchie - Mississippi",
      "Tallapoosa - Alabama",
      "Tama - Iowa",
      "Taney - Missouri",
      "Tangipahoa Parish - Louisiana",
      "Taos - New Mexico",
      "Tarrant - Texas",
      "Tate - Mississippi",
      "Tattnall - Georgia",
      "Taylor - Florida",
      "Taylor - Georgia",
      "Taylor - Iowa",
      "Taylor - Kentucky",
      "Taylor - Texas",
      "Taylor - West Virginia",
      "Taylor - Wisconsin",
      "Tazewell - Illinois",
      "Tazewell - Virginia",
      "Tehama - California",
      "Telfair - Georgia",
      "Teller - Colorado",
      "Tensas Parish - Louisiana",
      "Terrebonne Parish - Louisiana",
      "Terrell - Georgia",
      "Terrell - Texas",
      "Terry - Texas",
      "Teton - Idaho",
      "Teton - Montana",
      "Teton - Wyoming",
      "Texas - Missouri",
      "Texas - Oklahoma",
      "Thayer - Nebraska",
      "Thomas - Georgia",
      "Thomas - Kansas",
      "Thomas - Nebraska",
      "Throckmorton - Texas",
      "Thurston - Nebraska",
      "Thurston - Washington",
      "Tift - Georgia",
      "Tillamook - Oregon",
      "Tillman - Oklahoma",
      "Tinian Municipality - Commonwealth of the Northern Mariana Islands",
      "Tioga - New York",
      "Tioga - Pennsylvania",
      "Tippah - Mississippi",
      "Tippecanoe - Indiana",
      "Tipton - Indiana",
      "Tipton - Tennessee",
      "Tishomingo - Mississippi",
      "Titus - Texas",
      "Toa Alta Municipio - Puerto Rico",
      "Toa Baja Municipio - Puerto Rico",
      "Todd - Kentucky",
      "Todd - Minnesota",
      "Todd - South Dakota",
      "Tolland - Connecticut",
      "Tom Green - Texas",
      "Tompkins - New York",
      "Tooele - Utah",
      "Toole - Montana",
      "Toombs - Georgia",
      "Torrance - New Mexico",
      "Towner - North Dakota",
      "Towns - Georgia",
      "Traill - North Dakota",
      "Transylvania - North Carolina",
      "Traverse - Minnesota",
      "Travis - Texas",
      "Treasure - Montana",
      "Trego - Kansas",
      "Trempealeau - Wisconsin",
      "Treutlen - Georgia",
      "Trigg - Kentucky",
      "Trimble - Kentucky",
      "Trinity - California",
      "Trinity - Texas",
      "Tripp - South Dakota",
      "Troup - Georgia",
      "Trousdale - Tennessee",
      "Trujillo Alto Municipio - Puerto Rico",
      "Trumbull - Ohio",
      "Tucker - West Virginia",
      "Tulare - California",
      "Tulsa - Oklahoma",
      "Tunica - Mississippi",
      "Tuolumne - California",
      "Turner - Georgia",
      "Turner - South Dakota",
      "Tuscaloosa - Alabama",
      "Tuscarawas - Ohio",
      "Tuscola - Michigan",
      "Twiggs - Georgia",
      "Twin Falls - Idaho",
      "Tyler - Texas",
      "Tyler - West Virginia",
      "Tyrrell - North Carolina",
      "Uinta - Wyoming",
      "Uintah - Utah",
      "Ulster - New York",
      "Umatilla - Oregon",
      "Unicoi - Tennessee",
      "Union - Arkansas",
      "Union - Florida",
      "Union - Georgia",
      "Union - Illinois",
      "Union - Indiana",
      "Union - Iowa",
      "Union - Kentucky",
      "Union - Mississippi",
      "Union - New Jersey",
      "Union - New Mexico",
      "Union - North Carolina",
      "Union - Ohio",
      "Union - Oregon",
      "Union - Pennsylvania",
      "Union - South Carolina",
      "Union - South Dakota",
      "Union - Tennessee",
      "Union Parish - Louisiana",
      "Upshur - Texas",
      "Upshur - West Virginia",
      "Upson - Georgia",
      "Upton - Texas",
      "Utah - Utah",
      "Utuado Municipio - Puerto Rico",
      "Uvalde - Texas",
      "Val Verde - Texas",
      "Valencia - New Mexico",
      "Valley - Idaho",
      "Valley - Montana",
      "Valley - Nebraska",
      "Van Buren - Arkansas",
      "Van Buren - Iowa",
      "Van Buren - Michigan",
      "Van Buren - Tennessee",
      "Van Wert - Ohio",
      "Van Zandt - Texas",
      "Vance - North Carolina",
      "Vanderburgh - Indiana",
      "Vega Alta Municipio - Puerto Rico",
      "Vega Baja Municipio - Puerto Rico",
      "Venango - Pennsylvania",
      "Ventura - California",
      "Vermilion - Illinois",
      "Vermilion Parish - Louisiana",
      "Vermillion - Indiana",
      "Vernon - Missouri",
      "Vernon - Wisconsin",
      "Vernon Parish - Louisiana",
      "Victoria - Texas",
      "Vieques Municipio - Puerto Rico",
      "Vigo - Indiana",
      "Vilas - Wisconsin",
      "Villalba Municipio - Puerto Rico",
      "Vinton - Ohio",
      "Virginia Beach city - Virginia",
      "Volusia - Florida",
      "Wabash - Illinois",
      "Wabash - Indiana",
      "Wabasha - Minnesota",
      "Wabaunsee - Kansas",
      "Wadena - Minnesota",
      "Wagoner - Oklahoma",
      "Wahkiakum - Washington",
      "Wake - North Carolina",
      "Wakulla - Florida",
      "Waldo - Maine",
      "Walker - Alabama",
      "Walker - Georgia",
      "Walker - Texas",
      "Walla Walla - Washington",
      "Wallace - Kansas",
      "Waller - Texas",
      "Wallowa - Oregon",
      "Walsh - North Dakota",
      "Walthall - Mississippi",
      "Walton - Florida",
      "Walton - Georgia",
      "Walworth - South Dakota",
      "Walworth - Wisconsin",
      "Wapello - Iowa",
      "Ward - North Dakota",
      "Ward - Texas",
      "Ware - Georgia",
      "Warren - Georgia",
      "Warren - Illinois",
      "Warren - Indiana",
      "Warren - Iowa",
      "Warren - Kentucky",
      "Warren - Mississippi",
      "Warren - Missouri",
      "Warren - New Jersey",
      "Warren - New York",
      "Warren - North Carolina",
      "Warren - Ohio",
      "Warren - Pennsylvania",
      "Warren - Tennessee",
      "Warren - Virginia",
      "Warrick - Indiana",
      "Wasatch - Utah",
      "Wasco - Oregon",
      "Waseca - Minnesota",
      "Washakie - Wyoming",
      "Washburn - Wisconsin",
      "Washington - Alabama",
      "Washington - Arkansas",
      "Washington - Colorado",
      "Washington - Florida",
      "Washington - Georgia",
      "Washington - Idaho",
      "Washington - Illinois",
      "Washington - Indiana",
      "Washington - Iowa",
      "Washington - Kansas",
      "Washington - Kentucky",
      "Washington - Maine",
      "Washington - Maryland",
      "Washington - Minnesota",
      "Washington - Mississippi",
      "Washington - Missouri",
      "Washington - Nebraska",
      "Washington - New York",
      "Washington - North Carolina",
      "Washington - Ohio",
      "Washington - Oklahoma",
      "Washington - Oregon",
      "Washington - Pennsylvania",
      "Washington - Rhode Island",
      "Washington - Tennessee",
      "Washington - Texas",
      "Washington - Utah",
      "Washington - Vermont",
      "Washington - Virginia",
      "Washington - Wisconsin",
      "Washington Parish - Louisiana",
      "Washita - Oklahoma",
      "Washoe - Nevada",
      "Washtenaw - Michigan",
      "Watauga - North Carolina",
      "Watonwan - Minnesota",
      "Waukesha - Wisconsin",
      "Waupaca - Wisconsin",
      "Waushara - Wisconsin",
      "Wayne - Georgia",
      "Wayne - Illinois",
      "Wayne - Indiana",
      "Wayne - Iowa",
      "Wayne - Kentucky",
      "Wayne - Michigan",
      "Wayne - Mississippi",
      "Wayne - Missouri",
      "Wayne - Nebraska",
      "Wayne - New York",
      "Wayne - North Carolina",
      "Wayne - Ohio",
      "Wayne - Pennsylvania",
      "Wayne - Tennessee",
      "Wayne - Utah",
      "Wayne - West Virginia",
      "Waynesboro city - Virginia",
      "Weakley - Tennessee",
      "Webb - Texas",
      "Weber - Utah",
      "Webster - Georgia",
      "Webster - Iowa",
      "Webster - Kentucky",
      "Webster - Mississippi",
      "Webster - Missouri",
      "Webster - Nebraska",
      "Webster - West Virginia",
      "Webster Parish - Louisiana",
      "Weld - Colorado",
      "Wells - Indiana",
      "Wells - North Dakota",
      "West Baton Rouge Parish - Louisiana",
      "West Carroll Parish - Louisiana",
      "West Feliciana Parish - Louisiana",
      "Westchester - New York",
      "Western District - American Samoa",
      "Westmoreland - Pennsylvania",
      "Westmoreland - Virginia",
      "Weston - Wyoming",
      "Wetzel - West Virginia",
      "Wexford - Michigan",
      "Wharton - Texas",
      "Whatcom - Washington",
      "Wheatland - Montana",
      "Wheeler - Georgia",
      "Wheeler - Nebraska",
      "Wheeler - Oregon",
      "Wheeler - Texas",
      "White - Arkansas",
      "White - Georgia",
      "White - Illinois",
      "White - Indiana",
      "White - Tennessee",
      "White Pine - Nevada",
      "Whiteside - Illinois",
      "Whitfield - Georgia",
      "Whitley - Indiana",
      "Whitley - Kentucky",
      "Whitman - Washington",
      "Wibaux - Montana",
      "Wichita - Kansas",
      "Wichita - Texas",
      "Wicomico - Maryland",
      "Wilbarger - Texas",
      "Wilcox - Alabama",
      "Wilcox - Georgia",
      "Wilkes - Georgia",
      "Wilkes - North Carolina",
      "Wilkin - Minnesota",
      "Wilkinson - Georgia",
      "Wilkinson - Mississippi",
      "Will - Illinois",
      "Willacy - Texas",
      "Williams - North Dakota",
      "Williams - Ohio",
      "Williamsburg - South Carolina",
      "Williamsburg city - Virginia",
      "Williamson - Illinois",
      "Williamson - Tennessee",
      "Williamson - Texas",
      "Wilson - Kansas",
      "Wilson - North Carolina",
      "Wilson - Tennessee",
      "Wilson - Texas",
      "Winchester city - Virginia",
      "Windham - Connecticut",
      "Windham - Vermont",
      "Windsor - Vermont",
      "Winkler - Texas",
      "Winn Parish - Louisiana",
      "Winnebago - Illinois",
      "Winnebago - Iowa",
      "Winnebago - Wisconsin",
      "Winneshiek - Iowa",
      "Winona - Minnesota",
      "Winston - Alabama",
      "Winston - Mississippi",
      "Wirt - West Virginia",
      "Wise - Texas",
      "Wise - Virginia",
      "Wolfe - Kentucky",
      "Wood - Ohio",
      "Wood - Texas",
      "Wood - West Virginia",
      "Wood - Wisconsin",
      "Woodbury - Iowa",
      "Woodford - Illinois",
      "Woodford - Kentucky",
      "Woodruff - Arkansas",
      "Woods - Oklahoma",
      "Woodson - Kansas",
      "Woodward - Oklahoma",
      "Worcester - Maryland",
      "Worcester - Massachusetts",
      "Worth - Georgia",
      "Worth - Iowa",
      "Worth - Missouri",
      "Wrangell City and Borough - Alaska",
      "Wright - Iowa",
      "Wright - Minnesota",
      "Wright - Missouri",
      "Wyandot - Ohio",
      "Wyandotte - Kansas",
      "Wyoming - New York",
      "Wyoming - Pennsylvania",
      "Wyoming - West Virginia",
      "Wythe - Virginia",
      "Yabucoa Municipio - Puerto Rico",
      "Yadkin - North Carolina",
      "Yakima - Washington",
      "Yakutat City and Borough - Alaska",
      "Yalobusha - Mississippi",
      "Yamhill - Oregon",
      "Yancey - North Carolina",
      "Yankton - South Dakota",
      "Yates - New York",
      "Yauco Municipio - Puerto Rico",
      "Yavapai - Arizona",
      "Yazoo - Mississippi",
      "Yell - Arkansas",
      "Yellow Medicine - Minnesota",
      "Yellowstone - Montana",
      "Yoakum - Texas",
      "Yolo - California",
      "York - Maine",
      "York - Nebraska",
      "York - Pennsylvania",
      "York - South Carolina",
      "York - Virginia",
      "Young - Texas",
      "Yuba - California",
      "Yukon-Koyukuk Census Area - Alaska",
      "Yuma - Arizona",
      "Yuma - Colorado",
      "Zapata - Texas",
      "Zavala - Texas",
      "Ziebach - South Dakota"
    ]
  }
};

export default FilterPopulationService;